(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-expand"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('announcement-expand')) return;

    class AnnouncementExpand extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.announcement-expand__panel');
        this.backdrop = this.querySelector('[data-backdrop]');
        this.toggles = Array.from(this.querySelectorAll('[data-toggle]'));
        this.messages = Array.from(this.querySelectorAll('.announcement-expand__message'));
        this.msgIndex = 0;
        this.timer = null;
        this.interval = parseInt(this.dataset.interval, 10) || 4000;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rotate = this.dataset.rotate === 'true' && this.messages.length > 1 && !reducedMotion;

        this.toggles.forEach((btn) => btn.addEventListener('click', () => this.togglePanel()));
        if (this.backdrop) this.backdrop.addEventListener('click', () => this.closePanel());
        const closeBtn = this.querySelector('[data-close]');
        if (closeBtn) closeBtn.addEventListener('click', () => this.closePanel());
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.closePanel();
        });

        const prev = this.querySelector('[data-msg-prev]');
        const next = this.querySelector('[data-msg-next]');
        if (prev) prev.addEventListener('click', () => this.goMsg(this.msgIndex - 1, true));
        if (next) next.addEventListener('click', () => this.goMsg(this.msgIndex + 1, true));

        const bar = this.querySelector('.announcement-expand__bar');
        if (bar) {
          bar.addEventListener('mouseenter', () => this.stopRotate());
          bar.addEventListener('mouseleave', () => this.startRotate());
          bar.addEventListener('focusin', () => this.stopRotate());
          bar.addEventListener('focusout', () => this.startRotate());
        }

        const copyBtn = this.querySelector('[data-copy]');
        if (copyBtn) {
          const label = copyBtn.querySelector('[data-copy-text]');
          const original = label.textContent;
          copyBtn.addEventListener('click', () => {
            const code = copyBtn.dataset.code;
            const done = () => {
              label.textContent = copyBtn.dataset.copiedLabel;
              clearTimeout(this.copyTimer);
              this.copyTimer = setTimeout(() => {
                label.textContent = original;
              }, 2000);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(code).then(done).catch(done);
            } else {
              const tmp = document.createElement('textarea');
              tmp.value = code;
              document.body.appendChild(tmp);
              tmp.select();
              try {
                document.execCommand('copy');
              } catch (err) {
                /* sem clipboard disponível — o código segue visível para cópia manual */
              }
              document.body.removeChild(tmp);
              done();
            }
          });
        }

        this.goMsg(0);
        this.startRotate();
      }

      goMsg(rawIndex, fromUser) {
        const count = this.messages.length;
        if (!count) return;
        this.msgIndex = ((rawIndex % count) + count) % count;
        this.messages.forEach((msg, i) => {
          const active = i === this.msgIndex;
          msg.classList.toggle('is-active', active);
          if (msg.tagName === 'A' || msg.tagName === 'BUTTON') {
            if (active) msg.removeAttribute('tabindex');
            else msg.setAttribute('tabindex', '-1');
          }
        });
        if (fromUser && this.rotate) {
          this.stopRotate();
          this.startRotate();
        }
      }

      startRotate() {
        if (!this.rotate || this.timer || this.classList.contains('is-open')) return;
        this.timer = setInterval(() => this.goMsg(this.msgIndex + 1), this.interval);
      }

      stopRotate() {
        if (!this.timer) return;
        clearInterval(this.timer);
        this.timer = null;
      }

      togglePanel() {
        if (this.classList.contains('is-open')) this.closePanel();
        else this.openPanel();
      }

      openPanel() {
        this.classList.add('is-open');
        this.toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'true'));
        if (this.panel) this.panel.setAttribute('aria-hidden', 'false');
        this.stopRotate();
      }

      closePanel() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        this.toggles.forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
        if (this.panel) this.panel.setAttribute('aria-hidden', 'true');
        this.startRotate();
      }
    }

    customElements.define('announcement-expand', AnnouncementExpand);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    const changeUrl = drawer.dataset.cartChangeUrl;
    const updateUrl = drawer.dataset.cartUpdateUrl;
    const cartUrl = drawer.dataset.cartUrl;
    let lastFocus = null;

    // Idempotent on purpose. `cart:open` now also fires from INSIDE the drawer
    // (saving an edit re-renders the bag through it), and showModal() on an
    // already-open dialog throws InvalidStateError — and would overwrite
    // lastFocus with a node inside the drawer, so closing would return focus
    // into the thing that just closed.
    const openDialog = () => {
      if (drawer.open) return;
      lastFocus = document.activeElement;
      if (typeof drawer.showModal === 'function') {
        drawer.showModal();
      } else {
        drawer.setAttribute('open', '');
      }
    };

    const open = () => {
      openDialog();
      refresh();
    };

    const close = () => {
      if (typeof drawer.close === 'function') {
        drawer.close();
      } else {
        drawer.removeAttribute('open');
      }
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    // The engraving is ~2px tall in the 120px card, so the thumbnail's job is to
    // get the buyer to a size where it can be read. Its own dialog stacks above
    // the drawer in the top layer; the drawer stays open behind it.
    const zoomDialog = document.querySelector('[data-preview-zoom]');
    const zoomImage = zoomDialog && zoomDialog.querySelector('[data-preview-zoom-image]');
    let zoomOpener = null;

    const openZoom = (trigger) => {
      const source = trigger.dataset.previewSrc;
      if (!zoomDialog || !zoomImage || !source) return;
      zoomOpener = trigger;
      zoomImage.src = source;
      if (typeof zoomDialog.showModal === 'function') zoomDialog.showModal();
    };

    const closeZoom = () => {
      if (!zoomDialog) return;
      if (typeof zoomDialog.close === 'function') zoomDialog.close();
    };

    if (zoomDialog) {
      // Backdrop click and the close button. Esc is the dialog's own behaviour.
      zoomDialog.addEventListener('click', (event) => {
        if (event.target === zoomDialog || event.target.closest('[data-action="close-preview-zoom"]')) {
          closeZoom();
        }
      });
      // `close` fires for Esc, the button, and the backdrop alike — one place to
      // return focus, and to drop the src so a stale preview never flashes on the
      // next open.
      zoomDialog.addEventListener('close', () => {
        if (zoomOpener && document.contains(zoomOpener) && typeof zoomOpener.focus === 'function') {
          zoomOpener.focus();
        }
        zoomOpener = null;
        zoomImage.removeAttribute('src');
      });
    }

    // Open from any cart-icon trigger (header). Progressive enhancement:
    // without JS the <a href="/cart"> just navigates.
    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-action="open-cart"]');
      if (!opener) return;
      event.preventDefault();
      open();
    });

    // Allow other components (e.g. the PDP add-to-cart form) to open the drawer.
    // If the dispatcher passes freshly rendered section HTML, use it directly to
    // avoid an extra fetch; otherwise open and refresh from the server.
    document.addEventListener('cart:open', (event) => {
      const detail = event.detail || {};
      const sections = detail.sections;
      if (sections && replaceContent(sections['cart-drawer'])) {
        openDialog();
      } else {
        open();
      }
    });

    // The prazo estimator (snippets/prazo-estimator.liquid) dispatches this when a
    // delivery quote is computed or a carrier is chosen in the modal. Reflect the
    // chosen price into the summary's Entrega + Total rows (estimate only — the
    // real shipping is charged at checkout). Listener on document so it survives
    // the drawer's content re-render.
    document.addEventListener('prazo:selected', (event) => {
      const detail = event.detail || {};
      if (typeof detail.priceCents !== 'number') return;
      const deliveryEl = drawer.querySelector('[data-summary-delivery]');
      const totalEl = drawer.querySelector('[data-summary-total]');
      const totalValueEl = drawer.querySelector('[data-summary-total-value]');
      if (!deliveryEl || !totalEl || !totalValueEl) return;
      const formatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
      const cartTotalCents = parseInt(totalEl.getAttribute('data-cart-total-cents') || '0', 10);
      const grandTotalCents = cartTotalCents + detail.priceCents;
      // Update only the value span, keeping the row label/structure intact.
      deliveryEl.textContent = formatter.format(detail.priceCents / 100);
      totalValueEl.textContent = formatter.format(grandTotalCents / 100);
      // The grand total shifts when a delivery quote is added, so the COUNT
      // (not just the per-value) changes.
      const installmentEl = drawer.querySelector('[data-summary-installment]');
      if (installmentEl) {
        const maxInstallments = parseInt(installmentEl.getAttribute('data-installments-max') || '1', 10) || 1;
        const floorCents = parseInt(installmentEl.getAttribute('data-installments-floor-cents') || '9000', 10) || 9000;
        const installmentCount = Math.max(1, Math.min(maxInstallments, Math.floor(grandTotalCents / floorCents)));
        if (installmentCount <= 1) {
          installmentEl.hidden = true;
        } else {
          installmentEl.hidden = false;
          const perInstallment = formatter.format((grandTotalCents / installmentCount) / 100);
          const template = installmentEl.getAttribute('data-installment-tpl') || '';
          if (template) installmentEl.textContent = template.replace('__COUNT__', installmentCount).replace('__PRICE__', perInstallment);
        }
      }
    });

    // Collapsed/expanded state of the order-summary breakdown. Starts collapsed
    // (matching the server-rendered markup) and lives in the closure — not the
    // DOM — so it survives replaceContent() re-rendering the whole card.
    let summaryCollapsed = true;

    function applySummaryState() {
      const details = drawer.querySelector('[data-summary-details]');
      const toggle = drawer.querySelector('[data-action="toggle-summary"]');
      if (!details || !toggle) return;
      details.hidden = summaryCollapsed;
      toggle.setAttribute('aria-expanded', summaryCollapsed ? 'false' : 'true');
    }

    // Single delegated handler on the persistent <dialog>. Survives content
    // re-render because the dialog element itself is never replaced.
    // Delegated, like the click handler below: the drawer's content is replaced
    // wholesale on every cart response, and listeners bound to a field would go
    // with it. The commit rides `change` (blur or Enter) rather than `input`,
    // because each one is a write to the cart, not a keystroke echo.
    drawer.addEventListener('change', (event) => {
      const field = event.target.closest('[data-qty-input]');
      if (field && drawer.contains(field)) commitTypedQuantity(field);
    });
    drawer.addEventListener('keydown', onQuantityFieldKeydown);
    drawer.addEventListener('input', onQuantityFieldInput);

    drawer.addEventListener('click', (event) => {
      if (event.target === drawer) {
        close();
        return;
      }
      const trigger = event.target.closest('[data-action]');
      if (!trigger || !drawer.contains(trigger)) return;
      switch (trigger.dataset.action) {
        case 'close-cart':
          event.preventDefault();
          close();
          break;
        case 'increase':
        case 'decrease':
        case 'remove':
          handleQuantity(trigger);
          break;
        case 'toggle-details':
          event.preventDefault();
          toggleDetails(trigger);
          break;
        case 'zoom-preview':
          event.preventDefault();
          openZoom(trigger);
          break;
        case 'toggle-summary':
          event.preventDefault();
          summaryCollapsed = !summaryCollapsed;
          applySummaryState();
          break;
        case 'apply-coupon':
          event.preventDefault();
          applyTypedCoupon();
          break;
        case 'remove-coupon':
          event.preventDefault();
          removeCoupon();
          break;
        default:
          break;
      }
    });

    // Enter in the coupon input applies it, like the checkout's own field.
    drawer.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;
      if (!event.target.matches('[data-coupon-input]')) return;
      event.preventDefault();
      applyTypedCoupon();
    });

    // ── Coupon code ────────────────────────────────────────────────────────
    // One coupon at a time (they don't combine), and `discount` on /cart/update.js
    // replaces the stored list wholesale — so applying sends just the typed code and
    // removing sends nothing. Storing it on the cart session is also what carries it
    // into the checkout.

    function couponBlock() {
      return drawer.querySelector('[data-coupon]');
    }

    function applyTypedCoupon() {
      const block = couponBlock();
      if (!block) return;
      const input = block.querySelector('[data-coupon-input]');
      if (!input) return;
      const typed = input.value.trim().toUpperCase();
      if (!typed) {
        input.focus();
        return;
      }
      updateCoupons([typed], block);
    }

    function removeCoupon() {
      const block = couponBlock();
      if (block) updateCoupons([], block);
    }

    async function updateCoupons(codes, block) {
      block.dataset.state = 'applying';
      hideCouponError();
      try {
        const response = await postCoupons(codes, true);
        if (!response.ok) throw new Error('discount update failed');
        const data = await response.json();

        // Shopify answers 200 for any code and collapses three different outcomes
        // into `applicable: false` — a typo, a code outside this cart's scope, and a
        // code the platform dropped because a non-combinable discount already on the
        // cart is worth more (the volume ladder does exactly that). The response
        // can't tell them apart, but an existing discount on the cart distinguishes
        // the third case, which deserves its own message: nothing is wrong, the
        // buyer is simply already better off.
        //
        // Either way the code discounts nothing while still travelling to the
        // checkout, so drop it rather than leave a phantom behind.
        const codesOnCart = Array.isArray(data.discount_codes) ? data.discount_codes : [];
        const applicable = codesOnCart.filter((entry) => entry.applicable);
        if (applicable.length < codesOnCart.length) {
          await postCoupons(applicable.map((entry) => entry.code), false);
          const reason = data.total_discount > 0 ? 'outranked' : 'rejected';
          block.dataset.state = reason;
          showCouponError(reason);
          return;
        }

        block.dataset.state = '';
        // The pill carries no amount, so the breakdown has to be open for the buyer
        // to see what the code saved. Only ever opens it — removing a coupon leaves
        // the summary as the buyer left it.
        if (codes.length > 0) summaryCollapsed = false;
        const replaced = replaceContent(data.sections && data.sections['cart-drawer']);
        if (!replaced) window.location.assign(cartUrl);
      } catch (err) {
        block.dataset.state = '';
        showCouponError('generic');
      }
    }

    function postCoupons(codes, withSections) {
      const payload = { discount: codes.join(',') };
      if (withSections) {
        payload.sections = 'cart-drawer';
        payload.sections_url = window.location.pathname;
      }
      return fetch(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      });
    }

    function showCouponError(reason) {
      const message = drawer.querySelector('[data-coupon-error]');
      if (!message) return;
      const copy = {
        outranked: message.dataset.errorOutranked,
        rejected: message.dataset.errorRejected,
        generic: message.dataset.errorGeneric
      };
      message.textContent = copy[reason] || copy.generic;
      message.classList.toggle('cart-drawer__coupon-error--info', reason === 'outranked');
      message.hidden = false;
    }

    function hideCouponError() {
      const message = drawer.querySelector('[data-coupon-error]');
      if (message) message.hidden = true;
    }

    // Expand/collapse a line item's product details (icon attrs + add-ons + edit link).
    function toggleDetails(trigger) {
      const item = trigger.closest('.cart-item');
      if (!item) return;
      const open = item.classList.toggle('is-open');
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    // Refresh drawer content from the server (covers cross-tab changes on open).
    async function refresh() {
      try {
        const res = await fetch(`${cartUrl}?sections=cart-drawer`, {
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) return;
        const data = await res.json();
        replaceContent(data['cart-drawer']);
      } catch (err) {
        /* non-fatal: keep the server-rendered content already in the DOM */
      }
    }

    // Parse a rendered cart-drawer section string and swap the live content +
    // counts. The <dialog> itself is preserved (open state, focus, scroll).
    function replaceContent(html) {
      if (!html) return false;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const newContent = parsed.querySelector('.cart-drawer__content');
      const current = drawer.querySelector('.cart-drawer__content');
      if (!newContent || !current) return false;
      current.replaceWith(newContent);
      applySummaryState();
      const newCount = parsed.querySelector('[data-cart-count]');
      if (newCount) updateCounts(newCount.textContent.trim());
      return true;
    }

    function updateCounts(count) {
      const value = String(count);
      const isZero = value === '0' || value === '';
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = value;
        if (el.classList.contains('site-header__cart-badge')) {
          el.toggleAttribute('hidden', isZero);
        }
      });
    }

    // A Revelação de Fotos line lets the buyer type its photo count, so it
    // declares its own floor, ceiling and property set on the <li>. Every other
    // line keeps exactly the behavior it has always had — including the one
    // where decrementing the last unit removes it.
    //
    // Every write below replaces the drawer's content WHOLESALE, so they run one
    // at a time across all lines, not just per line: two lines changed in the
    // same network window can answer out of order, and the older response would
    // repaint the panel with a quantity the shopper has already moved past.
    let cartWrites = Promise.resolve();

    function enqueueCartWrite(task) {
      const run = cartWrites.then(task, task);
      cartWrites = run.catch(() => {});
      return run;
    }

    // The quantity a line is currently committing, so two taps before the first
    // response land two apart. Keyed by `_group` rather than by the line key: a
    // commit that carries properties REWRITES the key (it is
    // variantId:hash(properties)), so an entry keyed by it would address a line
    // that no longer exists by the time the next commit runs.
    const pendingQuantity = new Map();

    // NaN means "nothing typed" and belongs at the floor, but a number past the
    // ceiling belongs at the ceiling — and `parseInt` of enough digits is
    // `Infinity`, which the finite check used to send to the floor instead.
    function clampQuantity(li, quantity) {
      const floor = li.dataset.min ? parseInt(li.dataset.min, 10) : 0;
      const ceiling = li.dataset.max ? parseInt(li.dataset.max, 10) : Infinity;
      if (Number.isNaN(quantity)) return floor;
      return Math.min(ceiling, Math.max(floor, Math.floor(quantity)));
    }

    // /cart/change.js REPLACES a line's properties, so the whole set goes back:
    // dropping `_group` would orphan the add-ons and dropping `_preview_image`
    // would blank the card. `Quantidade` duplicates the line quantity onto the
    // ORDER, where a stale copy is a picking error, not a cosmetic one.
    //
    // The attribute holds what `item.properties | json` produces, and Liquid
    // serializes a properties hash as an ARRAY OF [key, value] PAIRS — not an
    // object. Reading it as an object silently yields no properties at all,
    // which looks exactly like a line that has none.
    //
    // `Quantidade` is SET, not merely refreshed: only a photo line publishes the
    // attribute at all, and one added before this shipped carries no such
    // property — leaving it out would send that order to picking without the
    // count it is packed by.
    function quantityProperties(li, quantity) {
      if (!li.dataset.lineProperties) return null;
      let pairs;
      try {
        pairs = JSON.parse(li.dataset.lineProperties);
      } catch (err) {
        return null;
      }
      if (!Array.isArray(pairs)) return null;
      const properties = {};
      pairs.forEach((pair) => {
        if (Array.isArray(pair) && pair.length === 2) properties[pair[0]] = pair[1];
      });
      properties.Quantidade = String(quantity);
      return properties;
    }

    // The value element is an <input> on a line the buyer can type into, and a
    // <span> everywhere else. Reading .textContent from an input yields '' -> 0,
    // and 0 is how this drawer REMOVES a line — every unit on it with it.
    function shownQuantity(li) {
      const valueEl = li.querySelector('[data-qty-value]');
      if (!valueEl) return 0;
      const shown = valueEl.tagName === 'INPUT' ? valueEl.value : valueEl.textContent;
      return parseInt(shown, 10) || 0;
    }

    // The property set with `Quantidade` removed: it is the one property a
    // quantity commit rewrites, so it cannot take part in telling lines apart.
    function stableProperties(li) {
      let pairs;
      try {
        pairs = JSON.parse(li.dataset.lineProperties);
      } catch (err) {
        return null;
      }
      if (!Array.isArray(pairs)) return null;
      return JSON.stringify(pairs.filter((pair) => Array.isArray(pair) && pair[0] !== 'Quantidade').sort());
    }

    // A queued commit's <li> is detached by the re-render that precedes it, and
    // its key went stale with the properties commit that caused the re-render.
    // Only property-carrying lines can move keys, so the rest pass through.
    //
    // Returns null when no single line answers for the node anymore: posting
    // the retired key would be a silent no-op against a line that is gone.
    function liveLine(li) {
      if (!li.dataset.lineProperties) return li;
      const lines = Array.from(drawer.querySelectorAll('[data-cart-item][data-line-properties]'));
      if (li.dataset.group) {
        return lines.find((el) => el.dataset.group === li.dataset.group) || li;
      }
      // A groupless photo line (added before `_group` shipped) moves keys too.
      // The key is variantId:hash(properties): the variant prefix is the stable
      // half, and the properties minus `Quantidade` break the tie between two
      // groupless lines of the same variant.
      const exact = lines.find((el) => el.dataset.key === li.dataset.key);
      if (exact) return exact;
      const variant = (li.dataset.key || '').split(':')[0];
      const stable = stableProperties(li);
      const matches = lines.filter((el) => !el.dataset.group
        && (el.dataset.key || '').split(':')[0] === variant
        && stableProperties(el) === stable);
      return matches.length === 1 ? matches[0] : null;
    }

    async function sendQuantity(li, quantity) {
      const body = {
        id: li.dataset.key,
        quantity,
        sections: 'cart-drawer',
        sections_url: window.location.pathname
      };
      const properties = quantityProperties(li, quantity);
      if (properties) body.properties = properties;

      li.setAttribute('aria-busy', 'true');
      hideError();
      try {
        const res = await fetch(changeUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
        if (!res.ok) throw new Error('change failed');
        const data = await res.json();
        const ok = replaceContent(data.sections && data.sections['cart-drawer']);
        if (!ok) {
          // Section payload missing/malformed -> last-resort fallback.
          window.location.assign(cartUrl);
        }
      } catch (err) {
        li.setAttribute('aria-busy', 'false');
        showError();
      }
    }

    // The line is resolved from the DOM inside the queued task, not before it:
    // the re-render that precedes this commit detaches the node it was called
    // with and mints a new key for the same line.
    function submitQuantity(li, quantity) {
      const id = li.dataset.group || li.dataset.key;
      const run = enqueueCartWrite(() => {
        const target = liveLine(li);
        if (!target) return undefined;
        return sendQuantity(target, quantity);
      })
        .finally(() => {
          const entry = pendingQuantity.get(id);
          if (entry && entry.done === run) pendingQuantity.delete(id);
        });
      pendingQuantity.set(id, { done: run, quantity });
      return run;
    }

    // The keys are read inside the queued task for the same reason: a commit
    // still in flight rewrites them, and an update posted against a key that no
    // longer exists is a silent no-op that leaves the line in the cart.
    function submitGroupRemoval(li, group) {
      return enqueueCartWrite(() => removeGroup(li, groupKeys(group)));
    }

    function groupKeys(group) {
      return Array.from(drawer.querySelectorAll('[data-cart-item]'))
        .filter((el) => el.dataset.group === group)
        .map((el) => el.dataset.key);
    }

    function commitTypedQuantity(field) {
      const li = field.closest('[data-cart-item]');
      if (!li) return Promise.resolve();
      const quantity = clampQuantity(li, parseInt(field.value, 10));
      // Show what was actually sent: a silent correction leaves the shopper
      // reading a number the cart never received.
      field.value = String(quantity);
      return submitQuantity(li, quantity);
    }

    function onQuantityFieldKeydown(event) {
      if (event.key !== 'Enter') return;
      const field = event.target.closest('[data-qty-input]');
      if (!field || !drawer.contains(field)) return;
      // Blur instead of committing here, so typed and stepped quantities leave
      // by one path. The field sits outside the coupon and checkout forms, so
      // Enter submits nothing.
      event.preventDefault();
      field.blur();
    }

    function onQuantityFieldInput(event) {
      const field = event.target.closest('[data-qty-input]');
      if (!field || !drawer.contains(field)) return;
      const digits = field.value.replace(/\D/g, '');
      if (digits === field.value) return;
      // Rewriting .value drops the caret to the end. Count the digits that
      // survived ahead of it and put it back there, so deleting a character
      // inside "1000" leaves the cursor where the shopper was working.
      const caret = field.selectionStart;
      const digitsBeforeCaret = field.value.slice(0, caret).replace(/\D/g, '').length;
      field.value = digits;
      if (field.setSelectionRange) field.setSelectionRange(digitsBeforeCaret, digitsBeforeCaret);
    }

    async function handleQuantity(trigger) {
      const li = trigger.closest('[data-cart-item]');
      if (!li) return;
      // Removing a grouped (personalized) album removes its add-ons too — but an
      // add-on chip (which also carries data-group) must remove only its own line.
      if (trigger.dataset.action === 'remove' && li.dataset.group && !li.dataset.addon) {
        return submitGroupRemoval(li, li.dataset.group);
      }
      // The buttons commit an ABSOLUTE quantity, and the field only changes when
      // a response re-renders the drawer. Two taps before the first response
      // would otherwise both read the same number and both send it — from 20 the
      // shopper would get 21, not 22.
      const inFlight = pendingQuantity.get(li.dataset.group || li.dataset.key);
      const current = inFlight ? inFlight.quantity : shownQuantity(li);
      let quantity = 0;
      if (trigger.dataset.action === 'increase') quantity = clampQuantity(li, current + 1);
      else if (trigger.dataset.action === 'decrease') quantity = clampQuantity(li, current - 1);
      return submitQuantity(li, quantity);
    }

    async function removeGroup(li, keys) {
      li.setAttribute('aria-busy', 'true');
      hideError();
      const updates = {};
      keys.forEach((k) => { updates[k] = 0; });
      try {
        const res = await fetch(updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections: 'cart-drawer', sections_url: window.location.pathname })
        });
        if (!res.ok) throw new Error('update failed');
        const data = await res.json();
        const ok = replaceContent(data.sections && data.sections['cart-drawer']);
        if (!ok) window.location.assign(cartUrl);
      } catch (err) {
        li.setAttribute('aria-busy', 'false');
        showError();
      }
    }

    function showError() {
      const el = drawer.querySelector('[data-cart-error]');
      if (!el) return;
      el.textContent = el.dataset.errorGeneric;
      el.hidden = false;
    }

    function hideError() {
      const el = drawer.querySelector('[data-cart-error]');
      if (el) el.hidden = true;
    }

    // Deep-link open: the retired /cart page redirects here as `/?cart=open`
    // (sections/cart.liquid). Open the drawer on load, then strip the param so a
    // later refresh or a shared/copied URL doesn't re-open it.
    const params = new URLSearchParams(window.location.search);
    if (params.get('cart') === 'open') {
      open();
      params.delete('cart');
      const query = params.toString();
      const cleanUrl = window.location.pathname + (query ? `?${query}` : '') + window.location.hash;
      window.history.replaceState({}, '', cleanUrl);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categoria-adicionais"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.categoria-adicionais').forEach(function (root) {
      const tabs = root.querySelectorAll('[data-adicionais-tab]');
      const dots = root.querySelectorAll('[data-adicionais-dot]');
      const panes = root.querySelectorAll('[data-adicionais-pane]');
      const heading = root.querySelector('[data-adicionais-heading]');
      const body = root.querySelector('[data-adicionais-body]');
      const cta = root.querySelector('[data-adicionais-cta]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          const idx = tab.dataset.adicionaisTab;

          tabs.forEach(function (t) {
            const active = t === tab;
            t.classList.toggle('is-active', active);
            t.setAttribute('aria-selected', active ? 'true' : 'false');
          });

          dots.forEach(function (d) {
            d.classList.toggle('is-active', d.dataset.adicionaisDot === idx);
          });

          panes.forEach(function (pane) {
            const isActive = pane.dataset.adicionaisPane === idx;
            pane.classList.toggle('is-active', isActive);
            // Autoplay doesn't fire on a pane that was display:none at load, so
            // drive play/pause on switch. Reset inactive panes to the first frame.
            const paneVideo = pane.querySelector('video');
            if (paneVideo) {
              if (isActive) {
                paneVideo.play().catch(function () {});
              } else {
                paneVideo.pause();
                paneVideo.currentTime = 0;
              }
            }
          });

          if (heading) heading.textContent = tab.dataset.label || '';
          if (body) body.textContent = tab.dataset.body || '';
          if (cta) {
            const text = tab.dataset.ctaText || '';
            const url = tab.dataset.ctaUrl || '';
            cta.textContent = text;
            cta.href = url || '#';
            cta.hidden = !(text && url);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categoria-hero"]) return;
  try {
    
  (function () {
    if (window.__categoriaHeroTabsInit) return;
    window.__categoriaHeroTabsInit = true;

    var TEXT_FADE_MS = 200;
    var RAIL_FADE_PX = 24;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    // The thumb mirrors the viewport onto the row: its width is the visible
    // fraction and its offset is the scrolled fraction, both of scrollWidth, so
    // the two percentages land on `width` and `left` without any conversion.
    function updateRail(rail) {
      var scroller = rail.querySelector('[data-hero-scroller]');
      var bar = rail.querySelector('[data-hero-railbar]');
      var thumb = rail.querySelector('[data-hero-railthumb]');
      if (!scroller || !bar || !thumb) return;

      var scrollWidth = scroller.scrollWidth;
      var clientWidth = scroller.clientWidth;
      var overflow = scrollWidth - clientWidth;

      // A row that fits gets nothing: a thumb spanning its whole track reads as a
      // disabled control rather than as "there is no more row".
      if (overflow <= 1) {
        bar.hidden = true;
        scroller.style.setProperty('--rail-fade-start', '0px');
        scroller.style.setProperty('--rail-fade-end', '0px');
        return;
      }

      bar.hidden = false;

      var left = scroller.scrollLeft;
      thumb.style.setProperty('--rail-thumb-width', (clientWidth / scrollWidth) * 100 + '%');
      thumb.style.setProperty('--rail-thumb-offset', (left / scrollWidth) * 100 + '%');

      // Fade only the side that still has row behind it — a fade over the true
      // end of the list would promise pills that do not exist.
      scroller.style.setProperty('--rail-fade-start', left > 1 ? RAIL_FADE_PX + 'px' : '0px');
      scroller.style.setProperty('--rail-fade-end', left < overflow - 1 ? RAIL_FADE_PX + 'px' : '0px');
    }

    // A selected pill sitting outside the visible slice makes the row look like
    // it starts somewhere else. Centre it, letting the browser clamp at the ends.
    function revealActiveTab(rail) {
      var scroller = rail.querySelector('[data-hero-scroller]');
      if (!scroller || scroller.scrollWidth - scroller.clientWidth <= 1) return;
      var active = scroller.querySelector('.categoria-hero__tab.is-active');
      if (!active) return;

      var target = active.offsetLeft - scroller.clientWidth / 2 + active.offsetWidth / 2;
      if (scroller.scrollTo) {
        scroller.scrollTo({ left: target, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      } else {
        scroller.scrollLeft = target;
      }
    }

    function eachRail(root, fn) {
      var rails = root.querySelectorAll('[data-hero-rail]');
      for (var i = 0; i < rails.length; i++) fn(rails[i]);
    }

    function initRail(rail) {
      if (rail.dataset.railInit) return;
      rail.dataset.railInit = '1';

      var scroller = rail.querySelector('[data-hero-scroller]');
      if (!scroller) return;

      scroller.addEventListener(
        'scroll',
        function () {
          updateRail(rail);
        },
        { passive: true }
      );

      updateRail(rail);
      revealActiveTab(rail);
    }

    function setText(root, tab) {
      var textBox = root.querySelector('[data-hero-text]');
      if (!textBox) return;
      var headingEl = textBox.querySelector('[data-hero-heading]');
      var subEl = textBox.querySelector('[data-hero-subheading]');

      // Fade out, rewrite at the midpoint, fade back in — swapping the copy
      // while it is still visible reads as a jump cut.
      textBox.classList.add('is-swapping');
      setTimeout(function () {
        if (headingEl) headingEl.textContent = tab.dataset.heading || '';
        if (subEl) subEl.textContent = tab.dataset.subheading || '';
        textBox.classList.remove('is-swapping');
      }, TEXT_FADE_MS);
    }

    function activate(root, tab) {
      var index = tab.getAttribute('data-hero-tab');

      // Match on the index, not on the node: the same pill exists twice (hero
      // and sticky bar), and identity would light up only the one clicked.
      var tabs = root.querySelectorAll('[data-hero-tab]');
      for (var i = 0; i < tabs.length; i++) {
        var isTarget = tabs[i].getAttribute('data-hero-tab') === index;
        tabs[i].classList.toggle('is-active', isTarget);
        if (isTarget) tabs[i].setAttribute('aria-current', 'true');
        else tabs[i].removeAttribute('aria-current');
      }

      var panels = root.querySelectorAll('[data-hero-panel]');
      for (var p = 0; p < panels.length; p++) {
        var isActive = panels[p].getAttribute('data-hero-panel') === index;
        panels[p].classList.toggle('is-active', isActive);
        panels[p].setAttribute('aria-hidden', isActive ? 'false' : 'true');
      }

      // Both rails carry a copy of the pill, so both need to bring it into view.
      eachRail(root, revealActiveTab);

      setText(root, tab);
    }

    // The bar rides in once the hero is fully past the top of the viewport —
    // the legacy watched for hero.getBoundingClientRect().bottom <= 0, which is
    // the same moment an observer at threshold 0 reports leaving upward.
    function initStickyTabs(root) {
      var bar = root.querySelector('[data-hero-sticky]');
      if (!bar || bar.dataset.stickyInit || !('IntersectionObserver' in window)) return;
      bar.dataset.stickyInit = '1';

      new IntersectionObserver(
        function (entries) {
          var entry = entries[0];
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', scrolledPast);
          bar.setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
        },
        { threshold: 0 }
      ).observe(root);
    }

    function initAll() {
      var roots = document.querySelectorAll('[data-hero-tabs]');
      for (var i = 0; i < roots.length; i++) {
        initStickyTabs(roots[i]);
        eachRail(roots[i], initRail);
      }
    }

    function refreshAllRails() {
      eachRail(document, updateRail);
    }

    window.addEventListener('resize', refreshAllRails, { passive: true });

    // Pill widths move when the webfont swaps in, and the row can cross the
    // overflow threshold with them — the measurement taken at DOMContentLoaded
    // is against fallback metrics.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshAllRails);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    // Editing the section replaces its DOM, taking the old observer with it.
    document.addEventListener('shopify:section:load', initAll);

    document.addEventListener('click', function (event) {
      var tab = event.target.closest('[data-hero-tab]');
      if (!tab) return;
      var root = tab.closest('[data-hero-tabs]');
      if (!root) return; // no tabbed hero around it — let the link navigate

      event.preventDefault();
      if (tab.getAttribute('aria-current') === 'true') return;

      activate(root, tab);

      // The grid section owns its own swap; the hero only says which collection.
      document.dispatchEvent(
        new CustomEvent('categoria:tab-change', {
          detail: { url: tab.getAttribute('data-collection-url') },
        })
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["categoria-product-grid"]) return;
  try {
    
  (function () {
    if (window.__categoriaGridInit) return;
    window.__categoriaGridInit = true;

    var inflightController = null;
    var inflightTimer = null;

    // ---- Price slider helpers ----

    function updatePriceVisual(slider) {
      var boundMin = parseFloat(slider.dataset.boundMin) || 0;
      var boundMax = parseFloat(slider.dataset.boundMax) || 0;
      if (boundMax <= boundMin) return;
      var minInput = slider.querySelector('[data-price-input-min]');
      var maxInput = slider.querySelector('[data-price-input-max]');
      var range    = slider.querySelector('[data-price-range]');
      var labelMin = slider.querySelector('[data-price-label-min]');
      var labelMax = slider.querySelector('[data-price-label-max]');
      if (!minInput || !maxInput || !range) return;

      var vmin = parseFloat(minInput.value);
      var vmax = parseFloat(maxInput.value);
      var leftPct  = ((vmin - boundMin) / (boundMax - boundMin)) * 100;
      var rightPct = ((vmax - boundMin) / (boundMax - boundMin)) * 100;
      range.style.left  = leftPct + '%';
      range.style.width = Math.max(0, rightPct - leftPct) + '%';
      if (labelMin) labelMin.textContent = 'R$ ' + Math.round(vmin);
      if (labelMax) labelMax.textContent = 'R$ ' + Math.round(vmax);
    }

    // Pattern from tmp/a.js: clamp each side strictly against the other on
    // every input event, so neither thumb can cross past its partner.
    function clampPrices(slider, changedSide) {
      var minInput = slider.querySelector('[data-price-input-min]');
      var maxInput = slider.querySelector('[data-price-input-max]');
      if (!minInput || !maxInput) return;
      var vmin = parseFloat(minInput.value);
      var vmax = parseFloat(maxInput.value);
      if (changedSide === 'min') {
        minInput.value = Math.min(vmin, vmax);
      } else {
        maxInput.value = Math.max(vmax, vmin);
      }
    }

    function initPriceSliders(root) {
      var sliders = root.querySelectorAll('[data-price-slider]');
      for (var i = 0; i < sliders.length; i++) {
        updatePriceVisual(sliders[i]);
      }
    }

    // ---- URL construction (slider commit / sort change) ----
    // Starts from current URL so Categoria/Photos filter params (set by chip
    // hrefs via Shopify's value.url_to_add/remove) are preserved, then
    // overrides only the slider params + sort_by.

    function buildUrlFromForm(form, sectionRoot) {
      var baseUrl = sectionRoot.getAttribute('data-section-url') || window.location.pathname;
      var params = new URLSearchParams(window.location.search);

      var sliders = form.querySelectorAll('[data-price-slider]');
      for (var s = 0; s < sliders.length; s++) {
        var slider = sliders[s];
        var minInput = slider.querySelector('[data-price-input-min]');
        var maxInput = slider.querySelector('[data-price-input-max]');
        if (!minInput || !maxInput) continue;
        var vmin = parseFloat(minInput.value);
        var vmax = parseFloat(maxInput.value);
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
        params.append('filter.v.price.gte', vmin.toFixed(2));
        params.append('filter.v.price.lte', vmax.toFixed(2));
      }

      var sortDropdown = sectionRoot.querySelector('[data-sort-dropdown]');
      var currentSort = sortDropdown ? sortDropdown.getAttribute('data-sort-current') : '';
      if (currentSort) params.set('sort_by', currentSort);
      else params.delete('sort_by');

      var qs = params.toString();
      return qs ? baseUrl + '?' + qs : baseUrl;
    }

    // ---- AJAX section refresh ----

    function fetchAndReplace(url, sectionRoot, immediate, skipPushState) {
      if (inflightTimer) { clearTimeout(inflightTimer); inflightTimer = null; }
      var delay = immediate ? 0 : 180;
      inflightTimer = setTimeout(function () {
        _doFetchAndReplace(url, sectionRoot, skipPushState);
      }, delay);
    }

    function _doFetchAndReplace(url, sectionRoot, skipPushState) {
      if (!sectionRoot) return;
      var sectionId = sectionRoot.getAttribute('data-section-id');
      if (!sectionId) return;

      if (inflightController) inflightController.abort();
      inflightController = new AbortController();

      // Use ?section_id= (singular, HTML response) — matches Dawn's pattern
      // and works reliably with OS 2.0 template-section IDs on shopify theme dev.
      var fetchUrl = url + (url.indexOf('?') === -1 ? '?' : '&') + 'section_id=' + encodeURIComponent(sectionId);
      sectionRoot.classList.add('categoria-grid--loading');

      fetch(fetchUrl, { headers: { 'Accept': 'text/html' }, signal: inflightController.signal })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          if (!html) throw new Error('Empty Section Rendering API response');
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newRoot = doc.querySelector('[data-section-id="' + sectionId + '"]');
          if (!newRoot) throw new Error('Section root not found in fetched HTML');
          var newInner = newRoot.querySelector('.categoria-grid__inner');
          var currentInner = sectionRoot.querySelector('.categoria-grid__inner');
          if (!newInner || !currentInner) throw new Error('.categoria-grid__inner wrapper missing');

          // A tab swap lands on a different collection, so the base URL that
          // sort/price rebuild from has to follow — it lives on the outer
          // element, which the inner-only replace below never touches.
          var newBaseUrl = newRoot.getAttribute('data-section-url');
          if (newBaseUrl) sectionRoot.setAttribute('data-section-url', newBaseUrl);

          var oldToggle = sectionRoot.querySelector('[data-filter-toggle]');
          var wasOpen = oldToggle && oldToggle.getAttribute('aria-expanded') === 'true';

          while (currentInner.firstChild) currentInner.removeChild(currentInner.firstChild);
          while (newInner.firstChild) currentInner.appendChild(newInner.firstChild);

          if (wasOpen) {
            var newToggle = sectionRoot.querySelector('[data-filter-toggle]');
            var newPanel  = sectionRoot.querySelector('[data-filter-panel]');
            if (newToggle) newToggle.setAttribute('aria-expanded', 'true');
            if (newPanel)  newPanel.setAttribute('data-state', 'open');
          }

          initPriceSliders(sectionRoot);
          if (!skipPushState && sectionRoot.dataset.tabSwapped !== 'true') {
            history.pushState({ catFilter: true }, '', url);
          }
        })
        .catch(function (err) {
          if (err.name === 'AbortError') return;
          console.error('[categoria-product-grid] filter apply failed:', err);
        })
        .finally(function () {
          sectionRoot.classList.remove('categoria-grid--loading');
        });
    }

    // ---- Family tabs (owned by categoria-hero) ----
    // The hero holds the tab strip; it only tells us which collection to show.
    // The address bar stays on the products page, so no pushState here — and
    // once a tab was used, later sort/filter calls must not push either.

    document.addEventListener('categoria:tab-change', function (event) {
      var url = event.detail && event.detail.url;
      if (!url) return;
      var gridRoot = document.querySelector('.categoria-grid[data-section-id]');
      if (!gridRoot) return;
      gridRoot.dataset.tabSwapped = 'true';
      fetchAndReplace(url, gridRoot, true, true);
    });

    // ---- Event delegation ----

    document.addEventListener('click', function (event) {
      // Filter panel toggle
      var toggle = event.target.closest('[data-filter-toggle]');
      if (toggle) {
        var panelId = toggle.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) {
          panel.setAttribute('data-state', expanded ? 'closed' : 'open');
          if (!expanded) initPriceSliders(panel);
        }
        return;
      }

      // Filter chip toggle — chip.href is value.url_to_add or value.url_to_remove
      // (computed by Shopify) for list/boolean filters. AJAX the href.
      var chip = event.target.closest('[data-filter-chip]');
      if (chip) {
        if (chip.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          return;
        }
        event.preventDefault();
        var pressed = chip.getAttribute('aria-pressed') === 'true';
        chip.setAttribute('aria-pressed', pressed ? 'false' : 'true');
        var sectionRoot = chip.closest('[data-section-id]');
        var chipHref = chip.getAttribute('href');
        if (sectionRoot && chipHref) {
          fetchAndReplace(chipHref, sectionRoot, false);
        }
        return;
      }

      // Active filter chip removal (href = value.url_to_remove)
      var remove = event.target.closest('[data-remove-chip]');
      if (remove) {
        event.preventDefault();
        var sRoot = remove.closest('[data-section-id]');
        fetchAndReplace(remove.getAttribute('href'), sRoot, true);
        return;
      }

      // Clear all
      var clear = event.target.closest('[data-filter-clear]');
      if (clear) {
        event.preventDefault();
        var sR = clear.closest('[data-section-id]');
        fetchAndReplace(clear.getAttribute('href'), sR, true);
        return;
      }

      // Load more
      var loadBtn = event.target.closest('[data-load-more]');
      if (loadBtn && !loadBtn.disabled) {
        event.preventDefault();
        handleLoadMore(loadBtn);
        return;
      }

      // Sort dropdown — toggle trigger
      var sortTrigger = event.target.closest('[data-sort-trigger]');
      if (sortTrigger) {
        var sortDD = sortTrigger.closest('[data-sort-dropdown]');
        var sortList = sortDD.querySelector('[data-sort-list]');
        var isOpen = sortTrigger.getAttribute('aria-expanded') === 'true';
        // Close other open sort dropdowns first
        document.querySelectorAll('[data-sort-trigger][aria-expanded="true"]').forEach(function (t) {
          if (t !== sortTrigger) {
            t.setAttribute('aria-expanded', 'false');
            var l = t.closest('[data-sort-dropdown]').querySelector('[data-sort-list]');
            if (l) l.setAttribute('hidden', '');
          }
        });
        sortTrigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) sortList.setAttribute('hidden', '');
        else sortList.removeAttribute('hidden');
        return;
      }

      // Sort option selection
      var sortOpt = event.target.closest('[data-sort-option-value]');
      if (sortOpt) {
        var dd = sortOpt.closest('[data-sort-dropdown]');
        var trig = dd.querySelector('[data-sort-trigger]');
        var listEl = dd.querySelector('[data-sort-list]');
        var valEl = dd.querySelector('[data-sort-value]');
        var newVal = sortOpt.getAttribute('data-sort-option-value');

        dd.setAttribute('data-sort-current', newVal);
        if (valEl) valEl.textContent = sortOpt.textContent.trim();
        dd.querySelectorAll('[data-sort-option-value]').forEach(function (o) {
          o.setAttribute('aria-selected', o === sortOpt ? 'true' : 'false');
        });
        if (trig) trig.setAttribute('aria-expanded', 'false');
        if (listEl) listEl.setAttribute('hidden', '');

        var sortSectionRoot = dd.closest('[data-section-id]');
        if (!sortSectionRoot) return;
        var sortPanelForm = sortSectionRoot.querySelector('[data-filter-panel] form');
        var sortUrl;
        if (sortPanelForm) {
          sortUrl = buildUrlFromForm(sortPanelForm, sortSectionRoot);
        } else {
          var sortParams = new URLSearchParams(window.location.search);
          sortParams.set('sort_by', newVal);
          var sortBaseUrl = sortSectionRoot.getAttribute('data-section-url') || window.location.pathname;
          sortUrl = sortBaseUrl + '?' + sortParams.toString();
        }
        fetchAndReplace(sortUrl, sortSectionRoot, true);
        return;
      }

      // Click outside any open sort dropdown closes it
      document.querySelectorAll('[data-sort-trigger][aria-expanded="true"]').forEach(function (t) {
        var d = t.closest('[data-sort-dropdown]');
        if (!d.contains(event.target)) {
          t.setAttribute('aria-expanded', 'false');
          var l = d.querySelector('[data-sort-list]');
          if (l) l.setAttribute('hidden', '');
        }
      });
    });

    // Esc closes any open sort dropdown
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('[data-sort-trigger][aria-expanded="true"]').forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var l = t.closest('[data-sort-dropdown]').querySelector('[data-sort-list]');
        if (l) l.setAttribute('hidden', '');
        t.focus();
      });
    });

    document.addEventListener('change', function (event) {
      // Price slider commit (release)
      var priceInput = event.target.closest('[data-price-input-min], [data-price-input-max]');
      if (priceInput) {
        var slider = priceInput.closest('[data-price-slider]');
        var side = priceInput.hasAttribute('data-price-input-min') ? 'min' : 'max';
        clampPrices(slider, side);
        updatePriceVisual(slider);
        var form = priceInput.closest('form');
        var sectionRoot2 = priceInput.closest('[data-section-id]');
        if (form && sectionRoot2) {
          fetchAndReplace(buildUrlFromForm(form, sectionRoot2), sectionRoot2, false);
        }
        return;
      }
    });

    // Live drag — visual only (no fetch)
    document.addEventListener('input', function (event) {
      var priceInput = event.target.closest('[data-price-input-min], [data-price-input-max]');
      if (!priceInput) return;
      var slider = priceInput.closest('[data-price-slider]');
      var side = priceInput.hasAttribute('data-price-input-min') ? 'min' : 'max';
      clampPrices(slider, side);
      updatePriceVisual(slider);
    });

    function handleLoadMore(btn) {
      var nextUrl = btn.dataset.nextUrl;
      var listId  = btn.getAttribute('aria-controls');
      var sectionRoot = btn.closest('[data-section-id]');
      if (!nextUrl || !sectionRoot) return;
      var sectionId = sectionRoot.getAttribute('data-section-id');
      var originalLabel = btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = btn.dataset.loadingLabel || 'Carregando…';
      var fetchUrl = nextUrl + (nextUrl.indexOf('?') === -1 ? '?' : '&') + 'sections=' + encodeURIComponent(sectionId);

      fetch(fetchUrl, { headers: { 'Accept': 'application/json' } })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function (json) {
          var html = json[sectionId];
          if (!html) throw new Error('Missing section HTML');
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newList = doc.getElementById(listId);
          var liveList = document.getElementById(listId);
          if (!newList || !liveList) throw new Error('Grid list not found');
          var newItems = Array.prototype.slice.call(newList.children);
          var firstNew = newItems[0] || null;
          newItems.forEach(function (item) { liveList.appendChild(item); });
          var newBtn = doc.querySelector('[data-load-more]');
          if (newBtn) {
            btn.dataset.nextUrl = newBtn.dataset.nextUrl;
            btn.textContent = originalLabel;
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
          } else {
            btn.parentNode.removeChild(btn);
          }
          if (firstNew) {
            var focusTarget = firstNew.querySelector('.card-product__title');
            if (focusTarget) { focusTarget.setAttribute('tabindex', '-1'); focusTarget.focus(); }
          }
        })
        .catch(function (err) {
          console.error('[categoria-product-grid] load-more failed:', err);
          btn.textContent = originalLabel;
          btn.disabled = false;
          btn.removeAttribute('aria-busy');
        });
    }

    // Initial init for any sliders present on first page load
    document.querySelectorAll('[data-section-id]').forEach(function (root) {
      initPriceSliders(root);
    });

    // Browser back/forward — re-sync section with URL
    window.addEventListener('popstate', function () {
      var section = document.querySelector('[data-section-id]');
      if (!section) return;
      // skipPushState=true so we don't push duplicate history entries when the
      // user navigates Back/Forward — popstate itself is the navigation event.
      fetchAndReplace(window.location.pathname + window.location.search, section, true, true);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["como-funciona-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.cffaq').forEach((root) => {
      const items = root.querySelectorAll('.cffaq__item');

      const setOpen = (item, open) => {
        const btn   = item.querySelector('[data-cffaq-toggle]');
        const panel = item.querySelector('.cffaq__answer');
        if (!btn || !panel) return;
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      };

      items.forEach((item) => {
        const btn = item.querySelector('[data-cffaq-toggle]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const wasOpen = item.classList.contains('is-open');
          items.forEach((i) => setOpen(i, false));
          if (!wasOpen) setOpen(item, true);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["como-funciona-steps"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-configurator]').forEach((cfg) => {
    const toggleBtn   = cfg.querySelector('[data-select-toggle]');
    const selectList  = cfg.querySelector('[data-select-list]');
    const selectName  = cfg.querySelector('[data-select-name]');
    const triggerSwatch = toggleBtn.querySelector('.cfstep__cfg-swatch--dyn');
    const preview     = cfg.querySelector('[data-preview]');

    /* ── Cover color dropdown ── */
    toggleBtn.addEventListener('click', () => {
      const open = toggleBtn.getAttribute('aria-expanded') === 'true';
      toggleBtn.setAttribute('aria-expanded', String(!open));
      selectList.hidden = open;
    });

    selectList.querySelectorAll('[data-color-opt]').forEach((opt) => {
      const selectOpt = () => {
        triggerSwatch.style.setProperty('--swatch', opt.dataset.hex);
        triggerSwatch.style.setProperty('--swatch-img', opt.dataset.img ? "url('" + opt.dataset.img + "')" : 'none');
        selectName.textContent = opt.dataset.name;
        preview.style.setProperty('--preview-bg', opt.dataset.hex);
        preview.style.setProperty('--preview-img', opt.dataset.img ? "url('" + opt.dataset.img + "')" : 'none');
        selectList.querySelectorAll('[data-color-opt]').forEach((o) => {
          o.classList.remove('is-selected');
          o.setAttribute('aria-selected', 'false');
        });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-selected', 'true');
        toggleBtn.setAttribute('aria-expanded', 'false');
        selectList.hidden = true;
      };
      opt.addEventListener('click', selectOpt);
      opt.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectOpt(); }
      });
    });

    document.addEventListener('click', (e) => {
      if (!cfg.contains(e.target)) {
        toggleBtn.setAttribute('aria-expanded', 'false');
        selectList.hidden = true;
      }
    });

    /* ── Engraving toggle ── */
    const engraveBtns = cfg.querySelectorAll('[data-engrave]');
    engraveBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        engraveBtns.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        preview.classList.remove('cfstep__cfg-preview--gold', 'cfstep__cfg-preview--silver');
        preview.classList.add('cfstep__cfg-preview--' + (btn.dataset.foil || 'gold'));
      });
    });

    /* ── Contenteditable placeholder ── */
    cfg.querySelectorAll('[data-placeholder]').forEach((el) => {
      el.addEventListener('focus', () => {
        if (el.textContent.trim() === el.dataset.placeholder) {
          const range = document.createRange();
          range.selectNodeContents(el);
          const sel = window.getSelection();
          sel.removeAllRanges();
          sel.addRange(range);
        }
      });
      el.addEventListener('blur', () => {
        if (el.textContent.trim() === '') {
          el.textContent = el.dataset.placeholder;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["deadline-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('deadline-popup')) return;

    class DeadlinePopup extends HTMLElement {
      connectedCallback() {
        this.storageKey = 'fn-deadline-popup-' + this.dataset.sectionId;

        /* Oculta linhas cujo prazo (AAAA-MM-DD) já passou. */
        const rows = Array.from(this.querySelectorAll('[data-expires]'));
        const now = new Date();
        rows.forEach((row) => {
          const iso = row.dataset.expires;
          if (!iso) return;
          const limit = new Date(iso + 'T23:59:59');
          if (!isNaN(limit) && now > limit) row.hidden = true;
        });
        this.visibleRows = rows.filter((row) => !row.hidden).length;

        this.querySelectorAll('[data-dp-close]').forEach((el) => {
          el.addEventListener('click', () => this.close());
        });
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.close();
        });

        /* Qualquer link terminando em #datas-limite abre o popup (ex.: CTA da barra de avisos). */
        document.addEventListener('click', (e) => {
          const link = e.target.closest && e.target.closest('a[href$="#datas-limite"]');
          if (!link) return;
          e.preventDefault();
          this.open();
        });

        /* No editor de temas, abre ao selecionar a seção. */
        document.addEventListener('shopify:section:select', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.open();
        });
        document.addEventListener('shopify:section:deselect', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.close();
        });

        /* Exibição automática: 1x a cada N dias, só se houver linha vigente. */
        if (this.dataset.auto === 'true' && this.visibleRows > 0 && this.allowedByFrequency()) {
          setTimeout(() => {
            this.open();
            this.markShown();
          }, parseInt(this.dataset.delay, 10) || 0);
        }
      }

      allowedByFrequency() {
        try {
          const ts = localStorage.getItem(this.storageKey);
          if (!ts) return true;
          const days = parseInt(this.dataset.days, 10) || 3;
          return Date.now() - parseInt(ts, 10) > days * 86400000;
        } catch (err) {
          return true;
        }
      }

      markShown() {
        try {
          localStorage.setItem(this.storageKey, String(Date.now()));
        } catch (err) {
          /* armazenamento indisponível — popup pode reaparecer */
        }
      }

      open() {
        this.classList.add('is-open');
        document.documentElement.style.overflow = 'hidden';
        const closeBtn = this.querySelector('.deadline-popup__close');
        if (closeBtn) closeBtn.focus();
      }

      close() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.documentElement.style.overflow = '';
      }
    }

    customElements.define('deadline-popup', DeadlinePopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq-accordion').forEach((root) => {
      const items = root.querySelectorAll('.faq-accordion__item');

      const setOpen = (item, open) => {
        const btn = item.querySelector('[data-faq-toggle]');
        const panel = item.querySelector('.faq-accordion__answer');
        if (!btn || !panel) return;
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        // JS-measured target height — animates to actual content size.
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      };

      items.forEach((item) => {
        const btn = item.querySelector('[data-faq-toggle]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const wasOpen = item.classList.contains('is-open');
          items.forEach((i) => setOpen(i, false));
          if (!wasOpen) setOpen(item, true);
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-faq-root]').forEach((root) => {
      initAccordion(root);
      initTabs(root);
      initSidebar(root);
    });

    function initAccordion(root) {
      const items = root.querySelectorAll('.faq-page__item');

      const setOpen = (item, open) => {
        const btn = item.querySelector('[data-faq-toggle]');
        const panel = item.querySelector('.faq-page__answer');
        if (!btn || !panel) return;
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.setAttribute('aria-hidden', open ? 'false' : 'true');
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0px';
      };

      items.forEach((item) => {
        const btn = item.querySelector('[data-faq-toggle]');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const wasOpen = item.classList.contains('is-open');
          items.forEach((i) => setOpen(i, false));
          if (!wasOpen) setOpen(item, true);
        });
      });
    }

    function initTabs(root) {
      const tabs = root.querySelectorAll('[data-faq-filter-btn]');
      const categories = root.querySelectorAll('.faq-page__category');
      const tabsContainer = root.querySelector('[data-faq-tabs]');

      const applyFilter = (filterId) => {
        root.setAttribute('data-faq-filter', filterId || '');
        categories.forEach((cat) => {
          if (!filterId || cat.dataset.category === filterId) {
            cat.setAttribute('data-category-active', '');
          } else {
            cat.removeAttribute('data-category-active');
          }
        });
        tabs.forEach((btn) => {
          btn.classList.toggle('is-active', (btn.dataset.faqFilterBtn || '') === (filterId || ''));
        });
      };

      tabs.forEach((btn) => {
        btn.addEventListener('click', () => {
          const filterId = btn.dataset.faqFilterBtn || '';
          applyFilter(filterId);
          if (tabsContainer && window.matchMedia('(max-width: 767px)').matches) {
            tabsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      applyFilter('');
    }

    function initSidebar(root) {
      const sidebar = root.querySelector('[data-faq-sidebar]');
      if (!sidebar) return;
      const items = sidebar.querySelectorAll('.faq-page__sidebar-item');
      const categories = root.querySelectorAll('.faq-page__category');

      const setActive = (anchorId) => {
        items.forEach((item) => {
          item.classList.toggle('is-active', (item.dataset.faqAnchor || '') === (anchorId || ''));
        });
      };

      sidebar.querySelectorAll('a.faq-page__sidebar-link').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const href = link.getAttribute('href');
          const target = href === '#faq-top'
            ? root.querySelector('#faq-top')
            : root.querySelector(href);
          if (target) {
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      if (!('IntersectionObserver' in window)) return;

      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible.length > 0) {
          setActive(visible[0].target.dataset.category);
        } else if (window.scrollY < (root.offsetTop || 0)) {
          setActive('');
        }
      }, {
        threshold: 0.3,
        rootMargin: '-20% 0px -50% 0px'
      });

      categories.forEach((cat) => observer.observe(cat));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('.site-header');
    if (!header) return;
    const dialog = header.querySelector('dialog.site-drawer');
    if (!dialog) return;

    const submenuPanels = Array.from(dialog.querySelectorAll('.site-drawer__panel--submenu'));

    const resetPanels = () => {
      submenuPanels.forEach((panel) => {
        panel.classList.remove('is-active');
        panel.hidden = true;
      });
    };

    const openSubmenu = (panelId) => {
      const panel = submenuPanels.find((p) => p.dataset.panel === panelId);
      if (!panel) return;
      panel.hidden = false;
      // Force a reflow so the slide-in transition runs from translateX(100%).
      void panel.offsetWidth;
      panel.classList.add('is-active');
    };

    const closeSubmenu = (panel) => {
      panel.classList.remove('is-active');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        panel.hidden = true;
        return;
      }
      const onEnd = () => {
        panel.hidden = true;
        panel.removeEventListener('transitionend', onEnd);
      };
      panel.addEventListener('transitionend', onEnd);
    };

    header.querySelector('[data-action="open-drawer"]')?.addEventListener('click', () => {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
    });

    dialog.querySelector('[data-action="close-drawer"]')?.addEventListener('click', () => {
      dialog.close();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.querySelectorAll('[data-open-submenu]').forEach((btn) => {
      btn.addEventListener('click', () => openSubmenu(btn.dataset.openSubmenu));
    });

    dialog.querySelectorAll('[data-close-submenu]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = btn.closest('.site-drawer__panel--submenu');
        if (panel) closeSubmenu(panel);
      });
    });

    dialog.addEventListener('close', resetPanels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('hero-slideshow')) return;

    class HeroSlideshow extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.hero-slideshow__slide'));
        if (this.slides.length < 2) return;

        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.fills = this.dots.map((dot) => dot.querySelector('.hero-slideshow__dot-fill'));
        this.pauseBtn = this.querySelector('[data-pause]');
        this.index = 0;
        this.elapsed = 0;
        this.raf = null;
        this.lastTs = null;
        this.userPaused = false;
        this.interval = parseInt(this.dataset.interval, 10) || 5000;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !reducedMotion;

        if (!this.autoplay) {
          this.classList.add('hero-slideshow--static');
          if (this.pauseBtn) this.pauseBtn.hidden = true;
        } else if (this.pauseBtn) {
          this.pauseBtn.addEventListener('click', () => this.toggleUserPause());
        }

        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        if (prev) prev.addEventListener('click', () => this.go(this.index - 1, true));
        if (next) next.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.stop();
          else this.start();
        });

        this.addEventListener('pointerdown', (e) => {
          this.swipeStartX = e.clientX;
        });
        this.addEventListener('pointerup', (e) => {
          if (this.swipeStartX == null) return;
          const delta = e.clientX - this.swipeStartX;
          this.swipeStartX = null;
          if (Math.abs(delta) < 40) return;
          this.go(delta < 0 ? this.index + 1 : this.index - 1, true);
        });

        this.tick = this.tick.bind(this);
        this.go(0);
        this.start();
      }

      /* Relógio único (rAF): preenche a pill ativa e, quando o preenchimento
         completa, avança o slide — timer e troca sempre em sincronia. */
      tick(ts) {
        if (this.lastTs == null) this.lastTs = ts;
        this.elapsed += ts - this.lastTs;
        this.lastTs = ts;

        if (this.elapsed >= this.interval) {
          this.elapsed = 0;
          this.go(this.index + 1);
        }

        const fill = this.fills[this.index];
        if (fill) fill.style.width = Math.min(this.elapsed / this.interval, 1) * 100 + '%';

        this.raf = requestAnimationFrame(this.tick);
      }

      toggleUserPause() {
        this.userPaused = !this.userPaused;
        this.pauseBtn.classList.toggle('is-paused', this.userPaused);
        this.pauseBtn.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
        this.pauseBtn.setAttribute(
          'aria-label',
          this.userPaused ? 'Retomar rotação automática' : 'Pausar rotação automática'
        );
        if (this.userPaused) this.stop();
        else this.start();
      }

      go(rawIndex, fromUser) {
        const count = this.slides.length;
        this.index = ((rawIndex % count) + count) % count;

        if (fromUser) this.elapsed = 0;
        this.fills.forEach((fill) => {
          if (fill) fill.style.width = '0%';
        });

        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.querySelectorAll('a, button').forEach((el) => {
            if (active) el.removeAttribute('tabindex');
            else el.setAttribute('tabindex', '-1');
          });
          slide.querySelectorAll('video').forEach((video) => {
            if (active) {
              const playing = video.play();
              if (playing && playing.catch) playing.catch(() => {});
            } else {
              video.pause();
            }
          });
        });

        this.dots.forEach((dot, i) => {
          if (i === this.index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      start() {
        if (!this.autoplay || this.userPaused || this.raf) return;
        this.lastTs = null;
        this.raf = requestAnimationFrame(this.tick);
      }

      stop() {
        if (!this.raf) return;
        cancelAnimationFrame(this.raf);
        this.raf = null;
      }
    }

    customElements.define('hero-slideshow', HeroSlideshow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-line-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(carousel) {
      var track = carousel.querySelector('[data-track]');
      var prev = carousel.querySelector('[data-direction="prev"]');
      var next = carousel.querySelector('[data-direction="next"]');
      if (!track) return;

      function updateState() {
        if (track.clientWidth === 0) return;
        var atStart = track.scrollLeft <= 1;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
        var hasOverflow = track.scrollWidth > track.clientWidth + 1;
        if (prev) prev.disabled = atStart || !hasOverflow;
        if (next) next.disabled = atEnd || !hasOverflow;
      }

      function scrollByCard(direction) {
        var card = track.querySelector('.card-product');
        if (!card) return;
        var step = card.getBoundingClientRect().width + 21;
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      if (prev)
        prev.addEventListener('click', function () {
          scrollByCard(-1);
        });
      if (next)
        next.addEventListener('click', function () {
          scrollByCard(1);
        });
      track.addEventListener('scroll', updateState);
      carousel.addEventListener('plg:activated', updateState);
      window.addEventListener('resize', updateState);
      updateState();
    }

    document.querySelectorAll('.product-line-grid').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');

      function activate(targetId) {
        tabs.forEach(function (tab) {
          var isActive = tab.getAttribute('data-tab') === targetId;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-panel') === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
        var activePanel = root.querySelector('[data-panel="' + targetId + '"]');
        var carousel = activePanel && activePanel.querySelector('[data-carousel]');
        if (carousel) carousel.dispatchEvent(new Event('plg:activated'));
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activate(tab.getAttribute('data-tab'));
        });
      });

      root.querySelectorAll('[data-carousel]').forEach(initCarousel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-popup"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('quiz-popup')) return;

    const esc = (s) =>
      String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    class QuizPopup extends HTMLElement {
      connectedCallback() {
        this.config = JSON.parse(this.querySelector('[data-quiz-config]').textContent);
        this.dialog = this.querySelector('dialog');
        this.bar = this.querySelector('[data-quiz-bar]');
        this.qHost = this.querySelector('[data-screen="q"]');
        /* Use a stable key instead of section.id: every new theme instance reset the
           memory and re-showed the popup to people who had already answered. */
        this.storageKey = 'fn-quiz-popup';
        this.migrateLegacyStorage();
        this.state = {};
        /* O caminho começa com a sub-pergunta mais comum para a barra de
           progresso nunca chegar a 100% antes da hora; é reconstruído quando
           o formato é escolhido. */
        this.path = ['intro', 'q_occasion', 'q_format', 'q_photos', 'email', 'result'];
        this.renderedAt = 0;
        this.timer = null;
        this.abort = new AbortController();
        const opts = { signal: this.abort.signal };
        /* Só a primeira instância na página reage a gatilhos globais e ao
           auto-show; duas empilhariam dois dialogs no mesmo clique. */
        this.isPrimary = document.querySelector('quiz-popup') === this;

        this.querySelector('[data-quiz-close]').addEventListener('click', () => this.close(), opts);
        this.querySelector('[data-quiz-start]').addEventListener('click', () => this.show('q_occasion'), opts);
        this.querySelector('[data-quiz-restart]').addEventListener('click', () => this.restart(), opts);
        this.querySelector('[data-quiz-coupon-copy]').addEventListener('click', () => this.copyCoupon(), opts);
        this.querySelector('[data-quiz-back-email]').addEventListener('click', () => {
          this.show(this.path[this.path.indexOf('email') - 1]);
        }, opts);
        this.querySelector('[data-quiz-form]').addEventListener('submit', (e) => {
          e.preventDefault();
          this.reveal();
        }, opts);

        /* Clique no ::backdrop chega no próprio <dialog>; o conteúdo cobre
           todo o card, então qualquer clique interno tem outro alvo. */
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.close();
        }, opts);

        /* Qualquer link para #quiz-memorias abre o quiz (CTAs de e-mail, avisos). */
        if (this.isPrimary) {
          document.addEventListener('click', (e) => {
            const link = e.target.closest && e.target.closest('a[href$="#quiz-memorias"]');
            if (!link) return;
            e.preventDefault();
            this.open();
          }, opts);
        }

        document.addEventListener('shopify:section:select', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.open();
        }, opts);
        document.addEventListener('shopify:section:deselect', (e) => {
          if (e.detail && e.detail.sectionId === this.dataset.sectionId) this.close();
        }, opts);

        if (!this.isPrimary) return;

        if (window.location.hash === '#quiz-memorias') {
          this.open();
        } else if (this.shouldAutoShow()) {
          this.timer = setTimeout(() => {
            this.timer = null;
            /* Revalida na hora de abrir: nesta janela (até 30s) o visitante
               pode ter aberto o quiz por link e concluído ou fechado. */
            if (!this.isConnected || this.everOpened || !this.shouldAutoShow()) return;
            this.open();
            this.markShown();
          }, parseInt(this.dataset.delay, 10) || 0);
        }
      }

      disconnectedCallback() {
        this.abort.abort();
        if (this.timer) clearTimeout(this.timer);
      }

      /* Merge the legacy entries instead of picking one: `done` is sticky (answering
         once on any theme means answered) and `ts` takes the latest sighting. Comparing
         the raw JSON strings would be wrong -- '{"ts":…}' sorts above '{"done":true,…}',
         so a merely-shown entry would beat a completed one and the popup would come
         back for exactly the people who finished it. */
      migrateLegacyStorage() {
        try {
          if (localStorage.getItem(this.storageKey)) return;
          const legacyPrefix = this.storageKey + '-';
          const merged = { done: false, ts: 0 };
          for (let index = 0; index < localStorage.length; index += 1) {
            const key = localStorage.key(index);
            if (!key || key.indexOf(legacyPrefix) !== 0) continue;
            let entry = null;
            try {
              entry = JSON.parse(localStorage.getItem(key));
            } catch (err) {
              continue;
            }
            if (!entry || typeof entry !== 'object') continue;
            if (entry.done) merged.done = true;
            if (typeof entry.ts === 'number' && entry.ts > merged.ts) merged.ts = entry.ts;
          }
          if (merged.done || merged.ts) localStorage.setItem(this.storageKey, JSON.stringify(merged));
        } catch (err) {
          /* storage errors follow the same path as readStorage */
        }
      }

      readStorage() {
        try {
          return JSON.parse(localStorage.getItem(this.storageKey)) || {};
        } catch (err) {
          return {};
        }
      }

      writeStorage(patch) {
        try {
          localStorage.setItem(this.storageKey, JSON.stringify(Object.assign(this.readStorage(), patch)));
        } catch (err) {
          /* armazenamento indisponível — o popup pode reaparecer */
        }
      }

      shouldAutoShow() {
        if (this.dataset.auto !== 'true') return false;
        if (this.dataset.suppress === 'true') return false;
        if (window.Shopify && window.Shopify.designMode) return false;
        const s = this.readStorage();
        if (s.done) return false;
        if (!s.ts) return true;
        const days = parseInt(this.dataset.days, 10) || 7;
        return Date.now() - s.ts > days * 86400000;
      }

      markShown() {
        this.writeStorage({ ts: Date.now() });
      }

      open() {
        this.everOpened = true;
        if (!this.dialog.open) {
          this.dialog.showModal();
          this.track('quiz_popup_shown');
        }
      }

      /* Track the quiz funnel with Shopify custom events (shown/completed/cta):
         without it there is no way to know whether the quiz converts. It must
         never break the quiz -- hence the empty catch. */
      track(name) {
        try {
          /* window.Shopify throughout, not the bare global: they are the same object
             in a browser, but mixing the two hides which one the guard actually
             protects and leaves the call unreachable anywhere window is not the
             global scope. */
          if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
            const published = window.Shopify.analytics.publish(name, {
              ocasiao: this.state.ocasiao || null,
              formato: this.state.formato || null,
              tamanho: this.state.tamanho || null
            });
            /* try/catch only covers a synchronous throw. publish() may hand back a
               promise, and a rejected one escapes as an unhandled rejection --
               noisy in the console and, in some browsers, a reported error on a
               page where nothing is actually broken. */
            if (published && typeof published.catch === 'function') published.catch(() => {});
          }
        } catch (err) {
          /* unavailable analytics must not affect the quiz */
        }
      }

      close() {
        if (this.dialog.open) this.dialog.close();
      }

      ordinalOf(screen) {
        if (screen === 'q_occasion') return 1;
        if (screen === 'q_format') return 2;
        return 3;
      }

      rebuildPath() {
        let mid;
        if (this.state.formato === 'pocket' || this.state.formato === 'table') mid = ['q_photos'];
        else if (this.state.formato === 'scrap') mid = ['q_scrapsize'];
        else mid = [];
        this.path = ['intro', 'q_occasion', 'q_format'].concat(mid, ['email', 'result']);
      }

      show(name) {
        this.querySelectorAll('.quiz-popup__screen').forEach((s) => s.classList.remove('is-active'));
        let el;
        if (name.indexOf('q_') === 0) {
          el = this.qHost;
          this.renderQuestion(name);
        } else {
          el = this.querySelector('[data-screen="' + name + '"]');
        }
        if (el) el.classList.add('is-active');
        let pos = this.path.indexOf(name);
        if (pos < 0) pos = 0;
        this.bar.style.width = Math.round((pos / (this.path.length - 1)) * 100) + '%';
        this.querySelector('.quiz-popup__pad').scrollTop = 0;
      }

      renderQuestion(name) {
        const q = this.config.questions[name];
        const pos = this.path.indexOf(name);
        const options = name === 'q_photos' ? this.config.photoOptions[this.state.formato] : q.options;
        const fmt = this.config.fmtDesc[this.state.ocasiao];
        const optsHtml = options
          .map((o) => {
            let od = o.d;
            if (name === 'q_format' && fmt && fmt[o.v]) od = fmt[o.v];
            return (
              '<button type="button" class="quiz-popup__opt" data-val="' + esc(o.v) + '">'
              + (o.ic ? '<span class="quiz-popup__opt-ic">' + esc(o.ic) + '</span>' : '')
              + '<span class="quiz-popup__opt-tx"><b>' + esc(o.t) + '</b><span>' + esc(od) + '</span></span>'
              + '</button>'
            );
          })
          .join('');
        this.qHost.innerHTML =
          '<div class="quiz-popup__brandbar"><span class="quiz-popup__brand">' + esc(this.config.strings.brand) + '</span>'
          + '<span class="quiz-popup__step">' + esc(this.config.strings.step) + ' ' + this.ordinalOf(name) + '</span></div>'
          + '<h2 class="quiz-popup__h-q">' + esc(q.title) + '</h2>'
          + (q.sub ? '<p class="quiz-popup__sub">' + esc(q.sub) + '</p>' : '')
          + '<div class="quiz-popup__options">' + optsHtml + '</div>'
          + (pos > 1
            ? '<div class="quiz-popup__backrow"><button type="button" class="quiz-popup__btn--ghost" data-quiz-back>'
              + esc(this.config.strings.back) + '</button></div>'
            : '');

        this.renderedAt = Date.now();

        this.qHost.querySelectorAll('.quiz-popup__opt').forEach((btn) => {
          btn.addEventListener('click', () => {
            /* As perguntas têm o mesmo layout: sem esta janela, o 2º clique de
               um duplo-toque cai na opção recém-renderizada e responde a
               pergunta seguinte sem o visitante ver. */
            if (Date.now() - this.renderedAt < 300) return;
            this.state[q.key] = btn.getAttribute('data-val');
            if (name === 'q_format') {
              /* Trocar de formato invalida o tamanho escolhido antes —
                 sem isso, quadro herdaria o tamanho do caminho anterior. */
              if (this.state.formato !== 'pocket' && this.state.formato !== 'table') delete this.state.tamanho;
              this.rebuildPath();
            }
            this.show(this.path[this.path.indexOf(name) + 1]);
          });
        });
        const back = this.qHost.querySelector('[data-quiz-back]');
        if (back) back.addEventListener('click', () => this.show(this.path[this.path.indexOf(name) - 1]));
      }

      reveal() {
        const nome = this.querySelector('[data-quiz-nome]').value.trim();
        const email = this.querySelector('[data-quiz-email]').value.trim();
        const ok = nome.length >= 2 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
        const err = this.querySelector('[data-quiz-err]');
        if (!ok) {
          err.classList.add('is-visible');
          return;
        }
        err.classList.remove('is-visible');
        this.state.nome = nome;
        this.state.email = email;
        this.writeStorage({ done: true, ts: Date.now() });
        this.track('quiz_popup_completed');
        this.submitToKlaviyo();
        this.buildResult();
        this.show('result');
      }

      resolveProduct() {
        const p = this.config.products;
        const f = this.state.formato;
        if (f === 'quadro') return Object.assign({ cap: '', alt: '' }, p.quadro);
        if (f === 'pocket') {
          const s = p.pocket.sizes[this.state.tamanho] || p.pocket.sizes.classic;
          return { name: s.name, dim: s.dim, cap: s.cap, alt: '', desc: p.pocket.desc, url: s.url };
        }
        if (f === 'table') {
          const t = p.table.sizes[this.state.tamanho] || p.table.sizes.tmidi;
          return { name: t.name, dim: t.dim, cap: t.cap, alt: t.alt, desc: p.table.desc, url: t.url };
        }
        const sc = p.scrap.sizes[this.state.tamanho] || p.scrap.sizes.smidi;
        return { name: sc.name, dim: sc.dim, cap: p.scrap.cap, alt: '', desc: p.scrap.desc, url: sc.url };
      }

      buildResult() {
        const prod = this.resolveProduct();
        this.querySelectorAll('[data-quiz-img]').forEach((el) => {
          const mine = el.getAttribute('data-quiz-img') === this.state.formato;
          el.hidden = !mine;
          /* Imagem `lazy` que nasceu dentro de um container `hidden` não é
             buscada quando ele é revelado; promover a `eager` dispara a
             carga só do formato recomendado. */
          const img = mine ? el.querySelector('img') : null;
          if (img && !img.complete) img.loading = 'eager';
          /* alt text for the recommended product, as in the prototype
             (rImg.alt = prod.name): the per-format alt announced "Classic Pocket"
             to someone who got a Mini. */
          if (img) img.alt = prod.name;
        });
        this.querySelector('[data-quiz-occ]').textContent = this.config.occ[this.state.ocasiao] || '';
        this.querySelector('[data-quiz-name]').textContent = prod.name;
        this.querySelector('[data-quiz-size]').textContent = prod.dim;
        this.querySelector('[data-quiz-desc]').textContent = prod.desc;
        this.querySelector('[data-quiz-cap]').textContent = prod.cap || '';
        this.querySelector('[data-quiz-alt]').textContent = prod.alt || '';
        this.querySelector('[data-quiz-coupon]').textContent = this.config.coupon.code;
        /* /discount/<code>?redirect=: the coupon applies itself at checkout -- without
           it the visitor has to remember and type a code they saw for two seconds. */
        const code = this.config.coupon.code;
        const cta = this.querySelector('[data-quiz-cta]');
        cta.href = code
          ? '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(prod.url)
          : prod.url;
        if (!cta.dataset.tracked) {
          cta.dataset.tracked = 'true';
          cta.addEventListener('click', () => this.track('quiz_popup_cta_clicked'));
        }
      }

      /* The coupon has to be typed at checkout and the CTA opens in _blank, so
         copying is what saves whoever comes back to this tab. navigator.clipboard
         needs a secure context and can be denied, so the fallback covers both
         cases; failing here must never break the result screen. */
      copyCoupon() {
        const code = this.config.coupon.code;
        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(code).then(
            () => this.showCopyFeedback(true),
            () => this.showCopyFeedback(this.copyFallback(code))
          );
          return;
        }
        this.showCopyFeedback(this.copyFallback(code));
      }

      copyFallback(code) {
        try {
          const field = document.createElement('textarea');
          field.value = code;
          /* readonly + offscreen: without it iOS opens the keyboard and scrolls. */
          field.setAttribute('readonly', '');
          field.style.position = 'fixed';
          field.style.top = '0';
          field.style.opacity = '0';
          this.appendChild(field);
          field.select();
          field.setSelectionRange(0, code.length);
          const copied = document.execCommand('copy');
          field.remove();
          return copied;
        } catch (err) {
          return false;
        }
      }

      showCopyFeedback(copied) {
        const button = this.querySelector('[data-quiz-coupon-copy]');
        const status = this.querySelector('[data-quiz-coupon-status]');
        const strings = this.config.strings;
        /* A blocked clipboard (permission denied, old WebView) would leave the visitor
           memorising the code. Selecting it puts a manual copy one gesture away:
           Cmd+C on desktop, "Copy" from the phone's own menu. */
        if (!copied) this.selectCoupon();
        if (status) status.textContent = copied ? strings.coupon_copied : strings.coupon_copy_failed;
        if (button) button.setAttribute('data-copied', copied ? 'true' : 'false');
        /* A single timer: repeated clicks restart the countdown instead of stacking. */
        clearTimeout(this.copyTimer);
        this.copyTimer = setTimeout(() => {
          if (status) status.textContent = '';
          if (button) button.removeAttribute('data-copied');
        }, 2500);
      }

      selectCoupon() {
        try {
          const code = this.querySelector('[data-quiz-coupon]');
          const selection = window.getSelection();
          if (!code || !selection) return;
          const range = document.createRange();
          range.selectNodeContents(code);
          selection.removeAllRanges();
          selection.addRange(range);
        } catch (err) {
          /* without a selection the status text still covers the case */
        }
      }

      restart() {
        this.state = {};
        this.path = ['intro', 'q_occasion', 'q_format', 'q_photos', 'email', 'result'];
        this.querySelector('[data-quiz-nome]').value = '';
        this.querySelector('[data-quiz-email]').value = '';
        this.show('intro');
      }

      submitToKlaviyo() {
        const k = this.config.klaviyo;
        const prod = this.resolveProduct();
        const listId = k.lists[this.state.ocasiao] || k.lists.outro;
        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Quiz Formato de Memórias',
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: this.state.email,
                    first_name: this.state.nome,
                    properties: {
                      quiz_ocasiao: this.state.ocasiao,
                      quiz_formato: this.state.formato,
                      quiz_tamanho: this.state.tamanho || null,
                      quiz_produto: prod.name,
                      quiz_cupom: this.config.coupon.code,
                      quiz_source: k.source
                    },
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                  }
                }
              }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        };
        if (!k.live) {
          /* Modo teste: registra o que seria enviado e não inscreve ninguém. */
          console.log('[quiz-popup] modo teste — lista:', listId, payload);
          return;
        }
        /* Sem lista ou company id o POST vira 400 e o lead se perde calado —
           os dois são texto livre no editor, então valem uma checagem. */
        if (!listId || !k.companyId) {
          console.warn('[quiz-popup] lista ou company id ausente; inscrição não enviada', { listId: listId, ocasiao: this.state.ocasiao });
          return;
        }
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(k.companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify(payload),
          /* Clicking the CTA (_blank) can unload the page with the POST still in
             flight; keepalive lets the browser finish it -- without it the lead is
             lost. */
          keepalive: true
        })
          .then((r) => {
            /* fetch resolve em 4xx: sem este check, uma lista errada é silenciosa. */
            if (!r.ok) console.warn('[quiz-popup] Klaviyo recusou a inscrição:', r.status, 'lista:', listId);
          })
          .catch((e) => {
            /* Falha de rede não pode travar o quiz — o resultado já foi exibido. */
            console.warn('[quiz-popup] Klaviyo indisponível:', e);
          });
      }
    }

    customElements.define('quiz-popup', QuizPopup);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  const sections = document.querySelectorAll('.reels-carousel');
  if (sections.length === 0) return;

  const SLOT_CLASSES = [
    'slot-active', 'slot-1-left', 'slot-1-right',
    'slot-2-left', 'slot-2-right', 'slot-3-left', 'slot-3-right',
    'slot-far-left', 'slot-far-right'
  ];

  function getSlotClass(offset) {
    if (offset === 0)  return 'slot-active';
    if (offset === -1) return 'slot-1-left';
    if (offset === 1)  return 'slot-1-right';
    if (offset === -2) return 'slot-2-left';
    if (offset === 2)  return 'slot-2-right';
    if (offset === -3) return 'slot-3-left';
    if (offset === 3)  return 'slot-3-right';
    if (offset < 0)    return 'slot-far-left';
    return 'slot-far-right';
  }

  const isMobile = function () {
    return window.matchMedia('(max-width: 767px)').matches;
  };

  sections.forEach(function (section) {
    const track = section.querySelector('[data-reels-track]');
    if (!track) return;
    const allCards = Array.from(track.querySelectorAll('[data-reel-card]'));
    if (allCards.length === 0) return;
    const originalCards = allCards.filter(function (c) { return !c.hasAttribute('data-duplicate'); });

    const productCard = section.querySelector('[data-reels-product]');
    const productImg = section.querySelector('[data-reels-product-image]');
    const productName = section.querySelector('[data-reels-product-name]');
    const productPrice = section.querySelector('[data-reels-product-price]');
    const prevBtn = section.querySelector('[data-reels-prev]');
    const nextBtn = section.querySelector('[data-reels-next]');

    const productsScript = section.querySelector('[data-reels-products]');
    let products = [];
    try { products = productsScript ? JSON.parse(productsScript.textContent) : []; } catch (_) { products = []; }

    const currency = function (cents) {
      try {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
      } catch (_) {
        return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
      }
    };

    let activeIndex = 0;
    let initialized = false;

    const getCards = function () {
      return isMobile() ? originalCards : allCards;
    };

    const applyLayout = function () {
      const cards = getCards();
      const total = cards.length;

      if (isMobile()) {
        var mTotal = originalCards.length;
        if (mTotal >= 5) {
          // Cyclical: rearrange visible cards by CSS order so active is always at position 1.
          // scrollLeft = MOBILE_STEP then consistently shows active at viewport_x = 20px.
          var prevIdx = ((activeIndex - 1) + mTotal) % mTotal;
          var nextIdx2 = (activeIndex + 1) % mTotal;
          var nextNextIdx = (activeIndex + 2) % mTotal;
          originalCards.forEach(function (card, i) {
            card.classList.remove('is-active', 'is-near');
            SLOT_CLASSES.forEach(function (c) { card.classList.remove(c); });
            if (i === activeIndex) {
              card.classList.add('is-active');
              card.style.order = '1';
              card.style.removeProperty('display');
            } else if (i === prevIdx) {
              card.style.order = '0';
              card.style.removeProperty('display');
            } else if (i === nextIdx2) {
              card.classList.add('is-near');
              card.style.order = '2';
              card.style.removeProperty('display');
            } else if (i === nextNextIdx) {
              card.style.order = '3';
              card.style.removeProperty('display');
            } else {
              card.style.removeProperty('order');
              card.style.display = 'none';
            }
          });
        } else {
          // Non-cyclical: linear layout, no order manipulation.
          originalCards.forEach(function (card, i) {
            card.classList.remove('is-active', 'is-near');
            SLOT_CLASSES.forEach(function (c) { card.classList.remove(c); });
            card.style.removeProperty('order');
            card.style.removeProperty('display');
            var dist = Math.abs(i - activeIndex);
            if (dist === 0) card.classList.add('is-active');
            else if (dist === 1) card.classList.add('is-near');
          });
        }
        return;
      }

      // Desktop: slot-based absolute layout. With duplication, total >= 7 always cyclical.
      const cyclical = total >= 5;
      const halfTotal = total / 2;

      cards.forEach(function (card, i) {
        let offset = i - activeIndex;
        if (cyclical) {
          if (offset > halfTotal) offset -= total;
          else if (offset < -halfTotal) offset += total;
        }
        SLOT_CLASSES.forEach(function (c) { card.classList.remove(c); });
        card.classList.remove('is-near', 'is-active');
        card.classList.toggle('is-active', offset === 0);
        card.classList.add(getSlotClass(offset));
      });
    };

    const updateProductCard = function () {
      const product = products[activeIndex % products.length];
      if (!product || !productCard) return;
      productCard.hidden = false;
      productCard.setAttribute('href', product.url);
      if (productImg) {
        productImg.setAttribute('src', product.image || '');
        productImg.setAttribute('alt', product.title);
      }
      if (productName) productName.textContent = product.title;
      if (productPrice) productPrice.textContent = currency(product.price_min);
    };

    const playActive = function () {
      allCards.forEach(function (card) {
        const video = card.querySelector('[data-reel-video]');
        if (!video) return;
        const cards = getCards();
        const cardIndex = cards.indexOf(card);
        if (cardIndex === activeIndex) {
          const promise = video.play();
          if (promise && typeof promise.then === 'function') {
            promise.catch(function () { /* autoplay blocked */ });
          }
        } else {
          video.pause();
          try { video.currentTime = 0; } catch (_) { /* preload=none seek may throw */ }
        }
      });
    };

    const updateButtons = function () {
      const cards = getCards();
      cards.forEach(function (card, i) {
        const muteBtn = card.querySelector('[data-reels-mute]');
        if (muteBtn) muteBtn.hidden = (i !== activeIndex);
        const playpauseBtn = card.querySelector('[data-reels-playpause]');
        if (playpauseBtn) playpauseBtn.hidden = (i !== activeIndex);
      });
    };

    // Non-active card width (148px) + gap (12px).
    // Cyclical mobile: active is always at order 1 (content_x=180); scrollLeft=160 → viewport_x=20.
    // Non-cyclical mobile: scrollLeft = activeIndex * MOBILE_STEP.
    var MOBILE_STEP = 160; // 148 + 12

    const goTo = function (index) {
      const cards = getCards();
      const total = cards.length;
      if (total >= 5) {
        activeIndex = ((index % total) + total) % total;
      } else {
        activeIndex = Math.max(0, Math.min(total - 1, index));
      }
      applyLayout();
      updateProductCard();
      playActive();
      updateButtons();
      if (prevBtn) prevBtn.hidden = (total < 5 && activeIndex === 0);
      if (nextBtn) nextBtn.hidden = (total < 5 && activeIndex === total - 1);
      if (isMobile()) {
        if (total >= 5) {
          // Cyclical: instant jump so card size CSS transitions provide the visual animation.
          track.scrollLeft = MOBILE_STEP;
        } else {
          track.scrollTo({ left: activeIndex * MOBILE_STEP, behavior: 'smooth' });
        }
      }
    };

    allCards.forEach(function (card) {
      card.addEventListener('click', function (e) {
        if (e.target.closest('[data-reels-mute]') || e.target.closest('[data-reels-playpause]')) return;
        const cards = getCards();
        const idx = cards.indexOf(card);
        if (idx >= 0) goTo(idx);
      });

      const muteBtn = card.querySelector('[data-reels-mute]');
      if (muteBtn) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          const video = card.querySelector('[data-reel-video]');
          if (!video) return;
          video.muted = !video.muted;
          muteBtn.classList.toggle('is-unmuted', !video.muted);
        });
      }

      const playpauseBtn = card.querySelector('[data-reels-playpause]');
      const video = card.querySelector('[data-reel-video]');
      if (playpauseBtn && video) {
        playpauseBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (video.paused) video.play();
          else video.pause();
        });
        video.addEventListener('play', function () {
          playpauseBtn.classList.remove('is-paused');
          playpauseBtn.setAttribute('aria-label', playpauseBtn.dataset.labelPause || '');
        });
        video.addEventListener('pause', function () {
          playpauseBtn.classList.add('is-paused');
          playpauseBtn.setAttribute('aria-label', playpauseBtn.dataset.labelPlay || '');
        });
      }
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(activeIndex + 1); });

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !initialized) {
          initialized = true;
          allCards.forEach(function (c) { c.classList.add('no-transition'); });
          goTo(activeIndex);
          void track.offsetWidth;
          allCards.forEach(function (c) { c.classList.remove('no-transition'); });
          track.classList.add('is-ready');
        }
      });
    }, { threshold: 0.25 });
    observer.observe(section);

    // Promote the posters after the critical path. This does not depend on
    // scrolling: the cards sit ~2700px below the fold, so nobody reaches them
    // before this runs anyway.
    function loadPosters() {
      allCards.forEach(function (c) {
        const v = c.querySelector('[data-reel-video]');
        if (v && v.dataset.poster) v.setAttribute('poster', v.dataset.poster);
      });
    }
    if ('requestIdleCallback' in window) {
      requestIdleCallback(loadPosters, { timeout: 3000 });
    } else {
      setTimeout(loadPosters, 2000);
    }

    // Re-apply layout on viewport resize crossing mobile/desktop breakpoint
    let lastIsMobile = isMobile();
    window.addEventListener('resize', function () {
      const nowMobile = isMobile();
      if (nowMobile !== lastIsMobile) {
        lastIsMobile = nowMobile;
        const cards = getCards();
        if (activeIndex >= cards.length) activeIndex = activeIndex % cards.length;
        applyLayout();
        updateButtons();
        if (nowMobile) {
          track.scrollLeft = originalCards.length >= 5 ? MOBILE_STEP : activeIndex * MOBILE_STEP;
        }
      }
    });

    if (isMobile()) {
      var touchStartX = 0;
      var touchStartY = 0;
      var touchStartScroll = 0;
      var dragCommitted = false; // true once the gesture is confirmed as horizontal

      function lerp(a, b, t) {
        return a + (b - a) * Math.max(0, Math.min(1, t));
      }

      function clearDragState() {
        // Removing --dragging re-enables CSS transitions so the final snap animates.
        section.classList.remove('reels-carousel--dragging');
        originalCards.forEach(function (card) {
          card.style.removeProperty('width');
          card.style.removeProperty('height');
        });
      }

      track.addEventListener('touchstart', function (e) {
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchStartScroll = track.scrollLeft;
        dragCommitted = false;
        section.classList.add('reels-carousel--dragging');
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        var dx = touchStartX - e.touches[0].clientX;
        var dy = touchStartY - e.touches[0].clientY;
        var absDx = Math.abs(dx);
        var absDy = Math.abs(dy);

        if (!dragCommitted) {
          // Wait for minimum movement before committing to a direction.
          if (absDx < 6 && absDy < 6) return;
          // Clearly vertical (2:1 ratio) — bail out and let page scroll.
          if (absDy > absDx * 2) {
            section.classList.remove('reels-carousel--dragging');
            return;
          }
          dragCommitted = true;
        }

        e.preventDefault(); // horizontal gesture — take full control

        // 1. Move track in lock-step with the finger.
        track.scrollLeft = touchStartScroll + dx;

        // 2. Interpolate sizes in real time (progress 0→1 over one MOBILE_STEP).
        var progress = absDx / MOBILE_STEP;
        var dir = dx > 0 ? 1 : -1;
        var mLen = originalCards.length;
        var nextIdx = mLen >= 5
          ? ((activeIndex + dir) + mLen) % mLen
          : activeIndex + dir;

        originalCards[activeIndex].style.width  = lerp(200, 148, progress) + 'px';
        originalCards[activeIndex].style.height = lerp(300, 260, progress) + 'px';

        if (mLen >= 5 || (nextIdx >= 0 && nextIdx < mLen)) {
          originalCards[nextIdx].style.width  = lerp(148, 200, progress) + 'px';
          originalCards[nextIdx].style.height = lerp(260, 300, progress) + 'px';
        }
      }, { passive: false });

      track.addEventListener('touchend', function (e) {
        if (!dragCommitted) {
          clearDragState();
          return;
        }

        var dx = touchStartX - e.changedTouches[0].clientX;

        // Re-enable CSS transitions BEFORE goTo() so the snap animates
        // smoothly from the current drag position to the final state.
        clearDragState();

        var snapTarget = originalCards.length >= 5 ? MOBILE_STEP : activeIndex * MOBILE_STEP;
        if (Math.abs(dx) >= MOBILE_STEP * 0.35) {
          goTo(dx > 0 ? activeIndex + 1 : activeIndex - 1);
        } else {
          track.scrollTo({ left: snapTarget, behavior: 'smooth' });
        }
      }, { passive: true });

      track.addEventListener('touchcancel', function () {
        clearDragState();
        var snapTarget = originalCards.length >= 5 ? MOBILE_STEP : activeIndex * MOBILE_STEP;
        track.scrollTo({ left: snapTarget, behavior: 'smooth' });
      }, { passive: true });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["volume-discount-ladder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const brlFormatter = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    const formatMoney = (cents) => brlFormatter.format((cents || 0) / 100);
    const newGroupId = () =>
      window.crypto && crypto.randomUUID
        ? crypto.randomUUID()
        : 'pac-' + Date.now() + '-' + Math.round(Math.random() * 1e6);

    document.querySelectorAll('[data-volume-discount]').forEach((root) => {
      const dataElement = root.querySelector('[data-vdl-data]');
      if (!dataElement) return;
      let data;
      try {
        data = JSON.parse(dataElement.textContent);
      } catch (parseError) {
        return;
      }
      const addUrl = root.getAttribute('data-add-url') || '/cart/add.js';
      const strings = data.strings || {};

      // Sizes = variants whose title parses to a photo count > 0, ascending.
      const sizes = (data.variants || [])
        .map((variant) => ({
          id: variant.id,
          photos: parseInt(variant.title, 10),
          price: variant.price,
          available: variant.available,
        }))
        .filter((variant) => variant.photos > 0)
        .sort((sizeA, sizeB) => sizeA.photos - sizeB.photos);
      const isScrapbook = data.isScrapbookHandle || sizes.length < 2;

      const postCart = (items) =>
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: 'cart-drawer', sections_url: window.location.pathname }),
        }).then((response) => response.json().then((body) => ({ ok: response.ok, body })));

      const openDrawer = (sections) =>
        document.dispatchEvent(new CustomEvent('cart:open', { detail: { sections } }));

      // ── Scrapbook fast path: N separate qty-1 lines (one per unit) ──
      // Each line needs a UNIQUE _group so Shopify does not merge identical
      // variant+properties lines into one qty-N line; the unique _group also
      // makes the cart drawer render each line stepper-free (remove only). A
      // shared _pacote marks them as one package for fulfillment.
      const addScrapbookPackage = (quantity, button) => {
        if (button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        const packageId = newGroupId();
        const items = [];
        for (let index = 0; index < quantity; index++) {
          items.push({ id: data.fallbackVariantId, quantity: 1, properties: { _group: newGroupId(), _pacote: packageId } });
        }
        postCart(items)
          .then(({ ok, body }) => {
            if (ok) openDrawer(body.sections);
          })
          .catch(() => {})
          .finally(() => button.removeAttribute('aria-busy'));
      };

      // ── Album modal ──
      const dialog = root.querySelector('[data-vdl-modal]');
      const rowTemplate = root.querySelector('[data-vdl-tpl-row]');
      const pillTemplate = root.querySelector('[data-vdl-tpl-pill]');
      const elements = dialog && {
        title: dialog.querySelector('[data-vdl-title]'),
        subtitle: dialog.querySelector('[data-vdl-sub]'),
        list: dialog.querySelector('[data-vdl-list]'),
        cta: dialog.querySelector('[data-vdl-cta]'),
        priceOriginal: dialog.querySelector('[data-vdl-orig]'),
        priceFinal: dialog.querySelector('[data-vdl-final]'),
        hint: dialog.querySelector('[data-vdl-hint]'),
        error: dialog.querySelector('[data-vdl-error]'),
        close: dialog.querySelector('[data-vdl-close]'),
      };

      let tierQuantity = 0;
      let tierPercentage = 0;
      let selections = [];
      let rows = [];
      let openRowIndex = 0;
      let busy = false;
      let lastFocus = null;

      const openDialog = () => {
        lastFocus = document.activeElement;
        if (typeof dialog.showModal === 'function') dialog.showModal();
        else dialog.setAttribute('open', '');
      };
      const closeDialog = () => {
        if (typeof dialog.close === 'function') dialog.close();
        else dialog.removeAttribute('open');
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      };

      const recalc = () => {
        const chosen = selections.filter(Boolean);
        const originalCents = chosen.reduce((sum, size) => sum + (size.price || 0), 0);
        // Keep the footer prices empty until at least one size is picked, so the
        // disabled CTA doesn't read "R$ 0,00 R$ 0,00".
        if (originalCents > 0) {
          elements.priceOriginal.textContent = formatMoney(originalCents);
          elements.priceFinal.textContent = formatMoney(Math.round(originalCents * (1 - tierPercentage / 100)));
        } else {
          elements.priceOriginal.textContent = '';
          elements.priceFinal.textContent = '';
        }
        const complete = chosen.length === tierQuantity;
        elements.cta.setAttribute('aria-disabled', complete ? 'false' : 'true');
        if (complete) elements.hint.textContent = '';
      };

      const setOpenRow = (rowIndex) => {
        openRowIndex = rowIndex;
        rows.forEach((row, index) => {
          const isOpen = index === openRowIndex;
          row.element.classList.toggle('vdl-modal__row--open', isOpen);
          row.header.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
      };

      const paintRow = (index) => {
        const row = rows[index];
        const selection = selections[index];
        row.prefix.textContent = strings.albumLabel + ' ' + (index + 1) + ': ';
        row.value.textContent = selection ? selection.photos + ' ' + strings.photosSuffix : strings.placeholder;
      };

      const selectSize = (index, size, selectedPill) => {
        if (!size.available) return;
        selections[index] = size;
        rows[index].pills.forEach((pill) => {
          const isOn = pill === selectedPill;
          pill.classList.toggle('vdl-modal__pill--on', isOn);
          pill.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        });
        rows[index].element.classList.remove('vdl-modal__row--missing');
        paintRow(index);
        recalc();
        let nextIndex = -1;
        for (let candidate = 0; candidate < tierQuantity; candidate++) {
          if (!selections[candidate]) {
            nextIndex = candidate;
            break;
          }
        }
        setOpenRow(nextIndex);
      };

      const buildRow = (index) => {
        const element = rowTemplate.content.firstElementChild.cloneNode(true);
        const header = element.querySelector('[data-vdl-row-header]');
        const prefix = element.querySelector('[data-vdl-row-prefix]');
        const value = element.querySelector('[data-vdl-row-value]');
        const panel = element.querySelector('[data-vdl-panel]');
        const pills = [];
        sizes.forEach((size) => {
          const pill = pillTemplate.content.firstElementChild.cloneNode(true);
          pill.textContent = size.photos;
          if (!size.available) {
            pill.disabled = true;
            pill.classList.add('vdl-modal__pill--out');
          }
          pill.addEventListener('click', (event) => {
            event.stopPropagation();
            selectSize(index, size, pill);
          });
          panel.appendChild(pill);
          pills.push(pill);
        });
        header.addEventListener('click', () => setOpenRow(openRowIndex === index ? -1 : index));
        rows[index] = { element, header, prefix, value, panel, pills };
        return element;
      };

      const buildModal = (quantity, percentage) => {
        tierQuantity = quantity;
        tierPercentage = percentage;
        selections = new Array(quantity).fill(null);
        rows = new Array(quantity);
        elements.title.textContent = strings.titlePrefix + ' ' + data.productTitle;
        elements.subtitle.textContent = '';
        elements.subtitle.appendChild(document.createTextNode(quantity + ' ' + strings.unitsWord + ' '));
        // Figma colors the whole "12% de desconto" phrase coral, not just the %.
        const percentageSpan = document.createElement('span');
        percentageSpan.className = 'vdl-modal__sub-pct';
        percentageSpan.textContent = percentage + strings.discountSuffix + ' ' + strings.discountWord;
        elements.subtitle.appendChild(percentageSpan);
        elements.list.textContent = '';
        for (let index = 0; index < quantity; index++) {
          elements.list.appendChild(buildRow(index));
          paintRow(index);
        }
        elements.error.textContent = '';
        elements.hint.textContent = '';
        setOpenRow(0);
        recalc();
      };

      const flashMissing = () => {
        elements.hint.textContent = strings.incompleteHint || '';
        rows.forEach((row, index) => {
          if (!selections[index]) {
            row.element.classList.add('vdl-modal__row--missing');
            setTimeout(() => row.element.classList.remove('vdl-modal__row--missing'), 1900);
          }
        });
      };

      const addAlbums = () => {
        if (busy) return;
        if (selections.filter(Boolean).length !== tierQuantity) {
          flashMissing();
          return;
        }
        busy = true;
        elements.cta.setAttribute('aria-busy', 'true');
        elements.error.textContent = '';
        // Unique _group per album → never merged (even when two albums pick the
        // same size/variant) and rendered stepper-free in the drawer; shared
        // _pacote marks the package.
        const packageId = newGroupId();
        const items = selections.map((size) => ({
          id: size.id,
          quantity: 1,
          properties: { _group: newGroupId(), _pacote: packageId, _pacote_size: String(size.photos) },
        }));
        postCart(items)
          .then(({ ok, body }) => {
            if (!ok) {
              elements.error.textContent = (body && (body.description || body.message)) || strings.addError;
              return;
            }
            closeDialog();
            openDrawer(body.sections);
          })
          .catch(() => {
            elements.error.textContent = strings.addError;
          })
          .finally(() => {
            busy = false;
            elements.cta.removeAttribute('aria-busy');
          });
      };

      if (dialog) {
        elements.cta.addEventListener('click', addAlbums);
        elements.close.addEventListener('click', closeDialog);
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) closeDialog();
        });
      }

      // ── Tier button routing ──
      // Front-first prototype (e.g. porta-retrato): the page is not wired to the
      // cart, so the tier buttons must not POST to /cart/add.js.
      const prototypeMode = root.dataset.prototype === 'true';
      root.querySelectorAll('[data-vdl-add]').forEach((button) => {
        button.addEventListener('click', () => {
          if (prototypeMode) return;
          const quantity = parseInt(button.getAttribute('data-quantity'), 10);
          const percentage = parseInt(button.getAttribute('data-percentage'), 10) || 0;
          if (!quantity) return;
          if (isScrapbook || !dialog) {
            addScrapbookPackage(quantity, button);
          } else {
            buildModal(quantity, percentage);
            openDialog();
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
